// import React, { useState, useEffect } from "react";
// import { Button, Modal, ModalBody } from "reactstrap";
// import Tooltip from "@material-ui/core/Tooltip";
// import { withRouter } from 'react-router-dom';
// import Checkbox from "./checkbox";

// import {
//   Link,
//   ApiUrl,
//   Axios,
//   DialogBox,
//   Row,
//   Col,
//   SELECT,
//   toast,
//   Loading,
//   moment,
//   TEXTFIELD,
//   DataTablePagination,
// } from "../../../../../components";

// import filter from "../../../../../assets/images/icone-de-filtre-grise.png";

// const {
//   API_SINGLE_LOTS_CASE,
//   API_ALLOW_LOT_CASES,
//   API_DIS_ALLOW_LOT_CASES,
//   API_DELETE_CASES,
//   API_FILTER_CASE,
//   API_FILTER_SELECT_DATA,
//   DELETE_RESPONDENT_BY_ADMIN
// } = ApiUrl;

// const Revenuetable = (props) => {
//   const [show, setShow] = useState(false);
//   const [state, setState] = useState({
//     temp: "",
//     disabled: false,
//   });
//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(20);
//   const [totalCount, setTotalCount] = useState(0);
//   const [filteredPage, setFilteredPage] = useState(0);
//   const [filteredRowsPerPage, setFilteredRowsPerPage] = useState(20);
//   const [filteredTotalCount, setFilteredTotalCount] = useState(0);
//   const [isFiltered, setIsFiltered] = useState(false);
//   const [limit, setLimit] = useState(20);
//   const [showVenue, setVenue] = useState(false);
//   const [showModal, setShowModal] = useState(false);
//   const [isCheckAll, setIsCheckAll] = useState(false);
//   const [isCheck, setIsCheck] = useState([]);
//   const [confirmDelete, setConfirmDelete] = useState(false);
//   const [showConfirmModal, setShowConfirmModal] = useState(false);
//   const [list, setList] = useState([]);
//   const [temp, setTemp] = useState([]);
//   const [open, setOpen] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [responseData, setResponseData] = useState([]);
//   const [stateData, setStateData] = useState([]);
//   const [venueData, setVenueData] = useState([]);
//   const [arbitratorData, setArbitratorData] = useState([]);
//   const [seatData, setSeatData] = useState([]);
//   const [lotData, setLotData] = useState([]);
//   const [clientData, setClientData] = useState([]);
//   const [count, setCount] = useState();
//   const [formData, setFormData] = useState({
//     status: "",
//     created_at: "",
//     created_at_from: "",
//     created_at_to: "",
//     hearing_date_from: "",
//     arbitrator: "",
//     hearing_date: "",
//     not_have_hearing_date: "",
//     state: "",
//     seat: "",
//     venue: "",
//     client: "",
//     lot: "",
//   });
//   const [id, setId] = useState("");
//   const [detail, setDetail] = useState({
//     title: "",
//     des: "",
//   });

//   // useEffect(() => {
//   //   if (props.props.location.name) {
//   //     localStorage.setItem("Pname", props.props.location.name);
//   //   }
//   //   if (props.props.location.description) {
//   //     localStorage.setItem("description", props.props.location.description);
//   //   }
//   //   setDetail({
//   //     title: localStorage.getItem("Pname"),
//   //     des: localStorage.getItem("description"),
//   //   });
//   // }, [props.props.location.name, props.props.location.description]);

//   const handleGoBack = () => {
//     localStorage.removeItem("Pname");
//     localStorage.removeItem("description");
//     props.history.goBack();
//   }

//   const handleCancel = () => {
//     setShow(false);
//   };

//   const handlePreview = (id) => {
//     setShow(true);
//   };

//   useEffect(() => {
//     if (!isFiltered) {
//       getTableRecords();
//     }
//   }, [page, rowsPerPage, props.edit, isFiltered]);

//   useEffect(() => {
//     if (isFiltered) {
//       handleConfirmSelection();
//     }
//   }, [filteredPage, filteredRowsPerPage]);

//   useEffect(() => {
//     filterData("state");
//     filterData("venue");
//     filterData("stages");
//     filterData("arbitrator");
//     filterData("seat");
//     filterData("lot");
//     filterData("lawFirmClient");
//   }, []);

//   const handleChangePage = (event, newPage) => {
//     if (isFiltered) {
//       setFilteredPage(newPage);
//     } else {
//       setPage(newPage);
//     }
//   };

//   const handleChangeRowsPerPage = (event) => {
//     const newRowsPerPage = parseInt(event.target.value, 10);
//     if (isFiltered) {
//       const newTotalPages = Math.ceil(filteredTotalCount / newRowsPerPage) || 1;
//       setFilteredRowsPerPage(newRowsPerPage);
//       setFilteredPage(Math.min(filteredPage, Math.max(newTotalPages - 1, 0)));
//     } else {
//       const newTotalPages = Math.ceil(totalCount / newRowsPerPage) || 1;
//       setRowsPerPage(newRowsPerPage);
//       setPage(Math.min(page, Math.max(newTotalPages - 1, 0)));
//     }
//   };

//   const handleSelectAll = (e) => {
//     setIsCheckAll(!isCheckAll);
//     setIsCheck(list.map((li) => li.id));
//     if (isCheckAll) {
//       setIsCheck([]);
//     }
//   };

//   // const handleClickOpen = () => {
//   //   setOpen(true);
//   //   // setId(id)
//   // };

//   const handleClickOpen = () => {
//     if (isCheck.length === 0) {
//       toast.error("Please select at least one case to delete.");
//       return;
//     }
//     setShowConfirmModal(true);
//   };

//   const handleClose = () => {
//     setOpen(false);
//   };

//   const handleClick = (e, id) => {
//     const isChecked = isCheck.includes(id);
//     if (isChecked) {
//       setIsCheck(isCheck.filter((item) => item !== id));
//     } else {
//       setIsCheck([...isCheck, id]);
//     }
//   };

//   const filterData = async (type) => {
//     try {
//       const response = await Axios.get(API_FILTER_SELECT_DATA + `${type}`);
//       if (type === "state") {
//         var data = response.data.data;
//         const statedata =
//           data.length > 0 &&
//           data.map((h, id) => {
//             return { [h.state]: h.state };
//           });
//         setStateData(statedata);
//       } else if (type === "venue") {
//         var data = response.data.data;
//         const venuedata =
//           data.length > 0 &&
//           data.map((h) => {
//             return { [h.venue]: h.venue };
//           });
//         setVenueData(venuedata);
//       }
//       //  else if (type === "stages") {
//       //   setStagesData(response.data.data.map((item) => item.stage));
//       //   value;
//       // }
//       else if (type === "arbitrator") {
//         var data = response.data.data;
//         const arbitdata =
//           data.length > 0 &&
//           data.map((h, id) => {
//             return { [h.name]: h.name };
//           });
//         setArbitratorData(arbitdata);
//       } else if (type === "lot") {
//         var data = response.data.data;
//         const lotdata =
//           data.length > 0 &&
//           data.map((h) => {
//             return { [h.title]: h.title };
//           });
//         setLotData(lotdata);
//       } else if (type === "seat") {
//         var data = response.data.data;
//         const seatdata =
//           data.length > 0 &&
//           data.map((h) => {
//             return { [h.seat]: h.seat };
//           });
//         setSeatData(seatdata);
//       } else if (type === "stages") {
//         var data = response.data.data;

//         setStagingData(response.data.data);
//       } else if (type === "lawFirmClient") {
//         var data = response.data.data;
//         const clientdata =
//           data.length > 0 &&
//           data.map((h, id) => {
//             return { [h.id]: h.name };
//           });
//         setClientData(clientdata);
//       }
//     } catch (error) {
//       console.error("Error filtering data");
//     }
//   };

//   // const apiUrl = `${API_SINGLE_LOTS_CASE}${extractedValue}`;
//   const getTableRecords = async () => {
//     setLoading(true);
//     const hash = window.location.hash;
//     const extractedValue = hash.split('/').pop();
//     const apiUrl = `${API_SINGLE_LOTS_CASE}${extractedValue}?limit=${rowsPerPage}&page=${page + 1}`;
//     Axios.Get(apiUrl)
//       .then((response) => {
//         const resData = response.data;
//         if (response.status == 200) {
//           setList(resData.data);
//           setTotalCount(resData.total);
//           setLoading(false);
//         } else {
//           toast.error(resData.error);
//         }
//       })
//       .catch((err) => {
//         console.log(err, "wwwwwwwww");
//       });
//   };


//   const deletecases = () => {
//     if (confirmDelete) {
//       const payload = {
//         cases_id: isCheck,
//       };
//       try {
//         setState({ ...state, disabled: true });
//         setShowConfirmModal(false);
//         setLoading(true);
//         Axios.post(DELETE_RESPONDENT_BY_ADMIN, payload)
//           .then((response) => {
//             if (response.status === 200) {
//               toast.success("Case deleted successfully");
//               const updatedList = list.filter((item) => !isCheck.includes(item.id));
//               setList(updatedList);
//               getTableRecords();
//               setIsCheck([]);
//             } else {
//               toast.error("Error deleting case");
//             }
//           })
//           .catch((err) => {
//             const errorMessage = err.response?.data?.message || "Error deleting case";
//             toast.error(errorMessage);
//           })
//           .finally(() => {
//             setState({ ...state, disabled: false });
//             setLoading(false);
//             setShowConfirmModal(false);
//             setConfirmDelete(false);
//           });
//       } catch (err) {
//         toast.error("Unexpected error occurred while deleting case.");
//         setState({ ...state, disabled: false });
//         setLoading(false);
//         setShowConfirmModal(false);
//         setConfirmDelete(false);
//       }
//     }
//   };

//   useEffect(() => {
//     if (confirmDelete) {
//       deletecases();
//     }
//   }, [confirmDelete]);

//   const handleConfirmDelete = () => {
//     setConfirmDelete(true);
//   };

//   const handleCancelDelete = () => {
//     setShowConfirmModal(false);
//     setConfirmDelete(false);
//   };

//   const handleChangeSeat = (e) => {
//     const { value } = e.target;
//     setFormData((prevState) => ({
//       ...prevState,
//       seat: value,
//     }));
//   };

//   const refresh = () => {
//     setIsFiltered(false);
//     setFilteredPage(0);
//     setFilteredRowsPerPage(20);
//     setFormData({});
//     getTableRecords(page);
//   };

//   const redirectPage = () => {
//     props.props.history.goBack();
//   };

//   const allowCases = async () => {
//     Axios.Post(API_ALLOW_LOT_CASES + props.edit)
//       .then((res) => {
//         console.log(res, "reskjkj");
//         let response = res.data;
//         setLoading(false);

//         if (response.status === 200) {
//           toast.success(response.message);
//           setTimeout(() => {
//             redirectPage();
//           }, 1000);
//         } else {
//           toast.error(res.message);
//         }
//       })
//       .catch((error) => {
//         console.log(error, "error");
//         setLoading(false);
//       });
//   };

//   const disallowCases = async () => {
//     Axios.Post(API_DIS_ALLOW_LOT_CASES + props.edit)
//       .then((res) => {
//         console.log(res, "reskjkj");
//         let response = res.data;
//         setLoading(false);

//         if (response.status === 200) {
//           toast.success(response.message);
//           setTimeout(() => {
//             redirectPage();
//           }, 1000);
//         } else {
//           toast.error(res.message);
//         }
//       })
//       .catch((error) => {
//         console.log(error, "error");
//         setLoading(false);
//       });
//   };

//   const deleteAction = (id) => {
//     Axios.post(API_DELETE_CASES + id)
//       .then((res) => {
//         setOpen(false);
//         toast.success(res.data.message);
//       })
//       .catch((err) => {
//         setOpen(false);
//         toast.success("Cases does not deleted!");
//       });
//   };

//   const formatDate = (timestamp) => {
//     const date = new Date(timestamp);
//     const options = {
//       month: "long",
//       day: "numeric",
//       year: "numeric",
//     };
//     return date.toLocaleDateString("en-US", options);
//   };

//   const toggleRev1 = (index) => {
//     setVenue((prev) => (prev === index ? null : index));
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prevState) => ({
//       ...prevState,
//       [name]: value,
//     }));
//   };

//   const handleDateChange = (e) => {
//     const { name, value } = e.target;
//     const formattedDate = value
//       ? new Date(value).toISOString().split("T")[0]
//       : "";
//     setFormData({ ...formData, [name]: formattedDate });
//   };

//   const handleHearingDateChange = (e) => {
//     const { value } = e.target;
//     setFormData((prevState) => ({
//       ...prevState,
//       hearing_date: value,
//     }));
//   };

//   const handlenotassignChange = (e) => {
//     const { value } = e.target;
//     setFormData((prevState) => ({
//       ...prevState,
//       not_have_hearing_date: value,
//     }));
//   };

//   const handleChangeState = (e) => {
//     const { value } = e.target;
//     setFormData((prevState) => ({
//       ...prevState,
//       state: value,
//     }));
//   };

//   const handleChangeLot = (e) => {
//     const { value } = e.target;
//     setFormData((prevState) => ({
//       ...prevState,
//       lot: value,
//     }));
//   };

//   const handleChangeClient = (e) => {
//     const { value } = e.target;
//     setFormData((prevState) => ({
//       ...prevState,
//       client: value,
//     }));
//   };

//   const handleChangeDateRange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prevState) => ({
//       ...prevState,
//       [name]: value,
//     }));
//   };

//   const handleChangeHearingDateRange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prevState) => ({
//       ...prevState,
//       [name]: value,
//     }));
//   };

//   const handleConfirmSelection = () => {
//     setLoading(true);
//     const filteredFormData = Object.fromEntries(
//       Object.entries(formData).filter(([_, value]) => value !== "")
//     );

//     const payload = {
//       ...filteredFormData,
//       limit: filteredRowsPerPage,
//       page: filteredPage + 1,
//     };

//     Axios.post(API_FILTER_CASE, payload)
//       .then((response) => {
//         setList(response.data?.data);
//         setFilteredTotalCount(response.data?.total);
//         setShowModal(false);
//         setIsFiltered(true);
//         setLoading(false);
//       })
//       .catch((error) => {
//         console.error("Error occurred while fetching data:", error);
//         setLoading(false);
//       });
//   };

//   const handleOpenModal1 = () => {
//     setShowModal(true);
//   };

//   const handleCloseModal = () => setShowModal(false);

//   const cataloge =
//     list &&
//     list?.length > 0 &&
//     list?.map((item, index) => {
//       return (
//         <div className="single-revenue-conatiner" key={item.id}>
//           <div className="revenue-table-heading">
//             <p className="checkbox-revenue">
//               {" "}
//               <span style={{ marginLeft: '9px' }}>
//                 <Checkbox
//                   key={item.id}
//                   type="checkbox"
//                   name={item.label}
//                   id={item.id}
//                   handleClick={(e) => handleClick(e, item.id)}
//                   isChecked={isCheck.includes(item.id)}
//                 />
//               </span>
//               <Link
//                 to={`/app/client/case-detail/${item.hash_id}`}
//                 data-toggle="tooltip"
//                 data-placement="top"
//                 title=""
//                 data-original-title="Case No."
//                 className="d-flex"
//               >
//                 {item.case_master_users.map((i) => {
//                   return (
//                     <div className="ml-2 text-capitalize">
//                       <span>
//                         {i.related_user_role == "Client" &&
//                           i.related_user_type == "claimant"
//                           ? `${i.related_user?.name}   vs`
//                           : ""}
//                       </span>

//                       <span>
//                         {i.related_user_role == "Party" &&
//                           i.related_user_type == "respondent"
//                           ? i.related_user?.name
//                           : ""}
//                       </span>
//                     </div>
//                   );
//                 })}
//               </Link>
//             </p>
//             <p className="checkbox-revenue-subtext">
//               <span> {item.date} </span>
//               <span className="revenue-status">{item.case_status}</span>
//             </p>
//           </div>
//           <Link to={`/app/client/case-detail/${item.hash_id}`}>
//             <div className="filesrevenue-conatiner">
//               <div className="filesrevenue-subconatiner">
//                 <div className="pov123 mt-3">
//                   <p>
//                     <span className="pov123Text">Case No.</span>
//                     {item.case_number}
//                   </p>
//                   <p>
//                     <span className="pov123Text">Filed On:</span>
//                     {moment(item.created_at).format("LLL")}
//                   </p>
//                 </div>
//               </div>

//               <div className="filesrevenue-subconatinerpov">
//                 {item.hearing &&
//                   item.hearing?.length > 0 &&
//                   item.hearing.map((hearing) => {
//                     const startDate = new Date(hearing?.hearing?.start_date);
//                     const currentDate = new Date();

//                     if (startDate >= currentDate) {
//                       return (
//                         <div
//                           className="filesrevenue-povBoxes"
//                           key={hearing.hearing_id}
//                         >
//                           <p>Next</p>
//                           <p>{formatDate(startDate)}</p>
//                         </div>
//                       );
//                     } else if (startDate < currentDate) {
//                       return (
//                         <div
//                           className="filesrevenue-povBoxes"
//                           key={hearing?.hearing_id}
//                         >
//                           <p>Previous</p>
//                           <p>{formatDate(startDate)}</p>
//                         </div>
//                       );
//                     }
//                   })}

//                 {!item.hearing ||
//                   (item?.hearing?.every(
//                     (hearing) =>
//                       new Date(hearing?.hearing?.start_date) >= new Date()
//                   ) && <></>)}
//               </div>
//             </div>
//           </Link>

//           {showVenue === index ? (
//             <div onClick={() => toggleRev1(index)}>
//               <h2 class="hr-lines">
//                 <span>
//                   <svg
//                     width="14"
//                     height="14"
//                     viewBox="0 0 14 14"
//                     fill="none"
//                     xmlns="http://www.w3.org/2000/svg"
//                   >
//                     <path
//                       d="M2 7.32349L7.32352 1.99996L12.6667 7.34311"
//                       stroke="#42526E"
//                       stroke-width="1.75"
//                       stroke-linecap="round"
//                       stroke-linejoin="round"
//                     />
//                   </svg>
//                 </span>
//               </h2>
//             </div>
//           ) : (
//             <div onClick={() => toggleRev1(index)} className="text-center">
//               <span className="arrow-conainer">
//                 <svg
//                   width="14"
//                   height="14"
//                   viewBox="0 0 14 14"
//                   fill="none"
//                   xmlns="http://www.w3.org/2000/svg"
//                 >
//                   <path
//                     d="M12.6667 7.34314L7.34317 12.6667L2.00002 7.32352"
//                     stroke="#42526E"
//                     stroke-width="1.75"
//                     stroke-linecap="round"
//                     stroke-linejoin="round"
//                   />
//                 </svg>
//               </span>
//             </div>
//           )}
//           {showVenue === index &&
//             item.metas.map((m) => {
//               return (
//                 <>
//                   <div className="revenue-state">
//                     <div className="revenue-state-box">
//                       <p className="text-court text-capitalize">
//                         {m.meta_key}:{" "}
//                       </p>
//                       <p className="text-state text-capitalize">
//                         {" "}
//                         {m.meta_value}{" "}
//                       </p>
//                     </div>
//                   </div>
//                 </>
//               );
//             })}
//         </div>
//       );
//     });

//   return (
//     <section className="Sales_analytics" style={{ paddingBottom: "42px" }}>
//       <DialogBox
//         title={"Cases"}
//         open={open}
//         onClose={handleClose}
//         deleteAction={deleteAction}
//       />
//       <div fluid>
//         <Row>
//           <Col md="8" xs="12" className="d-flex">
//             <Link
//               to="#"
//               onClick={handleGoBack}
//               style={{
//                 color: "grey",
//                 fontSize: "32px",
//               }}
//             >
//               <i
//                 class="zmdi zmdi-arrow-left"
//                 style={{
//                   fontSize: "22px",
//                   marginTop: "25px",
//                   marginLeft: "9px",
//                 }}
//               ></i>
//             </Link>
//             <div className="d-flex">
//               <p className="m-4">{localStorage.getItem("Pname")}</p>
//               <p className="m-4" style={{ whiteSpace: " pre-wrap" }}>
//                 {localStorage.getItem("description")}
//               </p>
//             </div>
//           </Col>

//           {/* <Col md="4" xs="12">
//             <Tooltip title="Need to select Template and checkboxe" arrow>
//               <button className=" mt-4 mr-5 allow-dis-btn" onClick={allowCases}>
//                 Approve
//               </button>
//             </Tooltip>

//             <Tooltip title="Need to select Template and checkboxe" arrow>
//               <button
//                 className=" mt-4 mr-5 dis-allow-btn"
//                 onClick={disallowCases}
//               >
//                 Dis Approve
//               </button>
//             </Tooltip>
//           </Col> */}

//         </Row>
//         <div className="revenueTable-conatiner">
//           <div className="revenueTable-pagination-box">
//             <div className="pgination-1st">
//               {" "}
//               <span className="check-po-icon">
//                 <div class="form-check">
//                   <input
//                     class="form-check-input"
//                     type="checkbox"
//                     id="flexCheckDefault"
//                     onChange={handleSelectAll}
//                     isChecked={isCheckAll}
//                   />
//                 </div>
//               </span>
//               <span className="check-po-icon" onClick={refresh}>
//                 <i class="zmdi zmdi-refresh-alt"></i>
//               </span>
//               {/* <span className="check-po-icon" onClick={handleClickOpen}>
//                 <i class="zmdi zmdi-delete"></i>
//               </span> */}
//               <span className="check-po-icon" onClick={handleOpenModal1}>
//                 <span className="mr-2 mb-1">Filter</span>

//                 <img
//                   src={filter}
//                   alt=""
//                   style={{ width: " 20px", height: " 18px" }}
//                 />
//                 {/* <i class="zmdi zmdi-filter-list"></i> */}
//               </span>

//               {/* <span className="check-po-icon" onClick={handleClickOpen}>
//                 <i className="zmdi zmdi-delete"></i>
//               </span> */}

//               <Modal isOpen={showModal} toggle={handleCloseModal}>
//                 <div className="modal-header">
//                   <button
//                     type="button"
//                     className="close"
//                     onClick={handleCloseModal}
//                   >
//                     <span>&times;</span>
//                   </button>
//                 </div>
//                 <ModalBody>
//                   <Row>
//                     <Col md="4" xs="12">
//                       <SELECT
//                         name="status"
//                         value={formData.status}
//                         onChange={handleChange}
//                         label="Status"
//                         data={[
//                           { pending: "Pending" },
//                           { disposed: "disposed" },
//                           { registered: "Registered" },
//                         ]}
//                       />
//                     </Col>
//                     <Col md="4" xs="12">
//                       <TEXTFIELD
//                         type="date"
//                         label="Created At"
//                         onChange={handleDateChange}
//                         value={formData.created_at}
//                         name="created_at"
//                       />
//                     </Col>

//                     <Col md="4">
//                       <SELECT
//                         onChange={handleChange}
//                         value={formData.arbitrator}
//                         name="arbitrator"
//                         label="Arbitrator"
//                         data={arbitratorData}
//                       />
//                     </Col>

//                     <Col md="4">
//                       <TEXTFIELD
//                         type="date"
//                         label="Hearing Date"
//                         onChange={handleHearingDateChange}
//                         value={formData.hearing_date}
//                         name="hearing_date"
//                       />
//                     </Col>
//                     <Col md="4">
//                       <SELECT
//                         onChange={handlenotassignChange}
//                         value={formData.not_have_hearing_date}
//                         name="not_have_hearing_date"
//                         label="Hearing not assigned"
//                         data={[{ yes: "Yes" }]}
//                       />
//                     </Col>
//                     <Col md="4">
//                       <SELECT
//                         onChange={handleChangeState}
//                         value={formData.state}
//                         name="state"
//                         label="State"
//                         data={stateData}
//                       />
//                     </Col>
//                     <Col md="4">
//                       <SELECT
//                         onChange={handleChangeSeat}
//                         value={formData.seat}
//                         name="seat"
//                         label="Seat"
//                         data={seatData}
//                       />
//                     </Col>
//                     <Col md="4">
//                       <SELECT
//                         onChange={handleChange}
//                         value={formData.venue}
//                         name="venue"
//                         id="variation-select-6"
//                         label="Venue"
//                         data={venueData}
//                       />
//                     </Col>

//                     <Col md="4">
//                       <SELECT
//                         name="lot"
//                         onChange={handleChangeLot}
//                         value={formData.client}
//                         id="variation-select-8"
//                         label="LOT"
//                         data={lotData}
//                       />
//                     </Col>
//                     <Col md="6" className="mt-4">
//                       <div>
//                         <label htmlFor="date_range" className="d-block">
//                           Created Date Range:
//                         </label>
//                         <div className="d-flex">
//                           <input
//                             type="date"
//                             id="date_range"
//                             name="created_at_from"
//                             value={formData.created_at_from}
//                             onChange={handleChangeDateRange}
//                             className="form-control mr-1"
//                           />
//                           <span className="align-self-center"> - </span>
//                           <input
//                             type="date"
//                             name="created_at_to"
//                             value={formData.created_at_to}
//                             onChange={handleChangeDateRange}
//                             className="form-control ml-1"
//                           />
//                         </div>
//                       </div>
//                     </Col>
//                     <Col md="6" className="mt-4">
//                       <div>
//                         <label htmlFor="date_range" className="d-block">
//                           Hearing Date Range:
//                         </label>
//                         <div className="d-flex">
//                           <input
//                             type="date"
//                             id="date_range"
//                             name="hearing_date_from"
//                             value={formData.hearing_date_from}
//                             onChange={handleChangeHearingDateRange}
//                             className="form-control mr-1"
//                           />
//                           <span className="align-self-center"> - </span>
//                           <input
//                             type="date"
//                             name="hearing_date_to"
//                             value={formData.hearing_date_to}
//                             onChange={handleChangeHearingDateRange}
//                             className="form-control ml-1"
//                           />
//                         </div>
//                       </div>
//                     </Col>
//                     <Col md="4" xs="12">
//                       <SELECT
//                         name="client"
//                         onChange={handleChangeClient}
//                         value={formData.client}
//                         id="variation-select-8"
//                         label="Client"
//                         data={clientData}
//                       />
//                     </Col>
//                   </Row>
//                   <Row>
//                     {" "}
//                     <Col md="4" xs="12">
//                       <Button
//                         color="primary"
//                         onClick={handleConfirmSelection}
//                         className="btn btn-warning add_claimant MuiButtonBase-root MuiButton-root jr-btn jr-btn-label left CBmargin CBmarginT M add-notes w-30"
//                       >
//                         Apply
//                       </Button>
//                     </Col>
//                   </Row>
//                 </ModalBody>
//               </Modal>
//             </div>
//             {/* <div className="pagination-conatinerw">
//               <div className="d-flex pagination-text justify-content-end">
//                 <span className="pto-5">Show</span>
//                 <select
//                   class="form-select page-select12"
//                   aria-label="Default select example"
//                   onChange={(event) => setLimit(event.target.value)}
//                 >
//                   {
//                     (list && list?.length > 10 && (
//                       <>
//                         <option selected>20</option>
//                         <option value="50">50</option>
//                         <option value="80">80</option>
//                         <option value="100">100</option>
//                       </>
//                     ))}
//                   <option value={list && list?.length}>
//                     {count == 0
//                       ? 0
//                       : filteredCatalogue && filteredCatalogue?.length > 0
//                         ? count
//                         : list && list?.length}{" "}
//                   </option>
//                 </select>
//                 <span className="pto-5">
//                   {" "}
//                   per page from{" "}
//                   {count == 0
//                     ? 0
//                     : filteredCatalogue && filteredCatalogue?.length > 0
//                       ? count
//                       : list && list?.length}{" "}
//                   results{" "}
//                 </span>
//               </div>
//               <nav>
//                 <ul className="pagination position-po pagination-text">
//                   <span className="pto-5">|</span>
//                   <li className="page-item pto-5">
//                     <span> Prev</span>
//                   </li>

//                   <li key="" className="">
//                     <a className="page-link" href="#">
//                       1
//                     </a>
//                   </li>

//                   <li className="page-item pto-5">
//                     <span>Next</span>
//                   </li>
//                 </ul>
//               </nav>
//             </div> */}
//           </div>

//           {loading === false && list && list?.length === 0 && (
//             <div className="n--data text-center m-5">No data Found!</div>
//           )}

//           {loading === true && (
//             <div className="n--data text-center m-5">
//               <Loading />
//             </div>
//           )}

//           <div className="revenue-scroll-container">{cataloge}</div>

//           <div>
//             {list && list.length > 0 && (
//               <div className="float-right">
//                 <DataTablePagination
//                   count={isFiltered ? filteredTotalCount : totalCount}
//                   rowsPerPage={isFiltered ? filteredRowsPerPage : rowsPerPage}
//                   page={isFiltered ? filteredPage : page}
//                   onChangePage={handleChangePage}
//                   onChangeRowsPerPage={handleChangeRowsPerPage}
//                   rowsPerPageOptions={[20, 50, 100, 200]}
//                 />
//               </div>
//             )}
//           </div>
//         </div>
//       </div>

//       <Modal isOpen={showConfirmModal} toggle={handleCancelDelete} className="full-screen-modal">
//         <div className=" modal-top d-flex justify-content-between py-1 pt-3 px-3">
//           <p className="fs-18 fw-bold">Delete Confirmation</p>
//           <p className="">
//             <span onClick={handleCancelDelete} className="modal-cancel12">
//               <i className="zmdi zmdi-close"></i>
//             </span>
//           </p>
//         </div>
//         <ModalBody className="pt-0">
//           <p>Are you sure you want to delete the selected cases?</p>
//           <Button
//             color="danger"
//             onClick={handleConfirmDelete}
//             disabled={state.disabled}
//           >
//             Confirm
//           </Button>
//           <Button
//             color="secondary"
//             onClick={handleCancelDelete}
//             className="ml-2"
//           >
//             Cancel
//           </Button>
//         </ModalBody>
//       </Modal>

//       <Modal isOpen={show} toggle={handleCancel}>
//         <p className="text-right m-0">
//           <span onClick={handleCancel} className="modal-cancel12">
//             <i class="zmdi zmdi-close"></i>
//           </span>
//         </p>
//         <ModalBody>
//           <p className="modal-case-12-heading">Case Limitation</p>
//           <form>
//             <Row>
//               <Col md="4" xs="12">
//                 <SELECT
//                   label="Chamber of arbitration"
//                   name={"role"}
//                   // value={role}
//                   // onChange={handleChange}
//                   data={[{ 1: "Active" }, { 0: "In Active" }]}
//                 />
//               </Col>
//               <Col md="4" xs="12">
//                 <SELECT
//                   label="Source Law Firm"
//                   name={"status"}
//                   // value={status}
//                   // onChange={handleChange}
//                   data={[{ 1: "Active" }, { 0: "In Active" }]}
//                 />
//               </Col>
//               <Col md="4" xs="12">
//                 <SELECT
//                   label="Arbitrator"
//                   name={"status"}
//                   // value={status}
//                   // onChange={handleChange}
//                   data={[{ 1: "Active" }, { 0: "In Active" }]}
//                 />
//               </Col>
//               <Col md="4" xs="12">
//                 <SELECT
//                   label="Arbitrator"
//                   name={"status"}
//                   // value={status}
//                   // onChange={handleChange}
//                   data={[{ 1: "Active" }, { 0: "In Active" }]}
//                 />
//               </Col>
//             </Row>
//           </form>
//         </ModalBody>
//       </Modal>
//     </section>
//   );
// };

// export default withRouter(Revenuetable);


// import React, { useState, useEffect } from "react";
// import { Button, Modal, ModalBody } from "reactstrap";
// import Tooltip from "@material-ui/core/Tooltip";
// import { withRouter } from 'react-router-dom';
// import Checkbox from "./checkbox";

// import {
//   Link,
//   ApiUrl,
//   Axios,
//   DialogBox,
//   Row,
//   Col,
//   SELECT,
//   toast,
//   Loading,
//   moment,
//   TEXTFIELD,
//   DataTablePagination,
// } from "../../../../../components";

// import filter from "../../../../../assets/images/icone-de-filtre-grise.png";

// const {
//   API_SINGLE_LOTS_CASE,
//   API_ALLOW_LOT_CASES,
//   API_DIS_ALLOW_LOT_CASES,
//   API_DELETE_CASES,
//   API_FILTER_CASE,
//   API_FILTER_SELECT_DATA
// } = ApiUrl;

// const Revenuetable = (props) => {
//   const [show, setShow] = useState(false);
//   const [state, setState] = useState({
//     temp: "",
//     disabled: false,
//   });
//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(20);
//   const [totalCount, setTotalCount] = useState(0);
//   const [filteredPage, setFilteredPage] = useState(0);
//   const [filteredRowsPerPage, setFilteredRowsPerPage] = useState(20);
//   const [filteredTotalCount, setFilteredTotalCount] = useState(0);
//   const [isFiltered, setIsFiltered] = useState(false);
//   const [limit, setLimit] = useState(20);
//   const [showVenue, setVenue] = useState(false);
//   const [showModal, setShowModal] = useState(false);
//   const [isCheckAll, setIsCheckAll] = useState(false);
//   const [isCheck, setIsCheck] = useState([]);
//   const [list, setList] = useState([]);
//   const [temp, setTemp] = useState([]);
//   const [open, setOpen] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [responseData, setResponseData] = useState([]);
//   const [stateData, setStateData] = useState([]);
//   const [venueData, setVenueData] = useState([]);
//   const [arbitratorData, setArbitratorData] = useState([]);
//   const [seatData, setSeatData] = useState([]);
//   const [lotData, setLotData] = useState([]);
//   const [clientData, setClientData] = useState([]);
//   const [count, setCount] = useState();
//   const [formData, setFormData] = useState({
//     status: "",
//     created_at: "",
//     created_at_from: "",
//     created_at_to: "",
//     hearing_date_from: "",
//     arbitrator: "",
//     hearing_date: "",
//     not_have_hearing_date: "",
//     state: "",
//     seat: "",
//     venue: "",
//     client: "",
//     lot: "",
//   });
//   const [id, setId] = useState("");
//   const [detail, setDetail] = useState({
//     title: "",
//     des: "",
//   });

//   // useEffect(() => {
//   //   if (props.props.location.name) {
//   //     localStorage.setItem("Pname", props.props.location.name);
//   //   }
//   //   if (props.props.location.description) {
//   //     localStorage.setItem("description", props.props.location.description);
//   //   }
//   //   setDetail({
//   //     title: localStorage.getItem("Pname"),
//   //     des: localStorage.getItem("description"),
//   //   });
//   // }, [props.props.location.name, props.props.location.description]);

//   const handleGoBack = () => {
//     localStorage.removeItem("Pname");
//     localStorage.removeItem("description");
//     props.history.goBack();
//   }

//   const handleCancel = () => {
//     setShow(false);
//   };

//   const handlePreview = (id) => {
//     setShow(true);
//   };

//   useEffect(() => {
//     if (!isFiltered) {
//       getTableRecords();
//     }
//   }, [page, rowsPerPage, props.edit, isFiltered]);

//   useEffect(() => {
//     if (isFiltered) {
//       handleConfirmSelection();
//     }
//   }, [filteredPage, filteredRowsPerPage]);

//   useEffect(() => {
//     filterData("state");
//     filterData("venue");
//     filterData("stages");
//     filterData("arbitrator");
//     filterData("seat");
//     filterData("lot");
//     filterData("lawFirmClient");
//   }, []);

//   const handleChangePage = (event, newPage) => {
//     if (isFiltered) {
//       setFilteredPage(newPage);
//     } else {
//       setPage(newPage);
//     }
//   };

//   const handleChangeRowsPerPage = (event) => {
//     const newRowsPerPage = parseInt(event.target.value, 10);
//     if (isFiltered) {
//       const newTotalPages = Math.ceil(filteredTotalCount / newRowsPerPage) || 1;
//       setFilteredRowsPerPage(newRowsPerPage);
//       setFilteredPage(Math.min(filteredPage, Math.max(newTotalPages - 1, 0)));
//     } else {
//       const newTotalPages = Math.ceil(totalCount / newRowsPerPage) || 1;
//       setRowsPerPage(newRowsPerPage);
//       setPage(Math.min(page, Math.max(newTotalPages - 1, 0)));
//     }
//   };

//   const handleSelectAll = (e) => {
//     setIsCheckAll(!isCheckAll);
//     setIsCheck(list.map((li) => li.id));
//     if (isCheckAll) {
//       setIsCheck([]);
//     }
//   };

//   const handleClickOpen = () => {
//     setOpen(true);
//     // setId(id)
//   };

//   const handleClose = () => {
//     setOpen(false);
//   };

//   const handleClick = (e, id) => {
//     const isChecked = isCheck.includes(id);
//     if (isChecked) {
//       setIsCheck(isCheck.filter((item) => item !== id));
//     } else {
//       setIsCheck([...isCheck, id]);
//     }
//   };

//   const filterData = async (type) => {
//     try {
//       const response = await Axios.get(API_FILTER_SELECT_DATA + `${type}`);
//       if (type === "state") {
//         var data = response.data.data;
//         const statedata =
//           data.length > 0 &&
//           data.map((h, id) => {
//             return { [h.state]: h.state };
//           });
//         setStateData(statedata);
//       } else if (type === "venue") {
//         var data = response.data.data;
//         const venuedata =
//           data.length > 0 &&
//           data.map((h) => {
//             return { [h.venue]: h.venue };
//           });
//         setVenueData(venuedata);
//       }
//       //  else if (type === "stages") {
//       //   setStagesData(response.data.data.map((item) => item.stage));
//       //   value;
//       // }
//       else if (type === "arbitrator") {
//         var data = response.data.data;
//         const arbitdata =
//           data.length > 0 &&
//           data.map((h, id) => {
//             return { [h.name]: h.name };
//           });
//         setArbitratorData(arbitdata);
//       } else if (type === "lot") {
//         var data = response.data.data;
//         const lotdata =
//           data.length > 0 &&
//           data.map((h) => {
//             return { [h.title]: h.title };
//           });
//         setLotData(lotdata);
//       } else if (type === "seat") {
//         var data = response.data.data;
//         const seatdata =
//           data.length > 0 &&
//           data.map((h) => {
//             return { [h.seat]: h.seat };
//           });
//         setSeatData(seatdata);
//       } else if (type === "stages") {
//         var data = response.data.data;

//         setStagingData(response.data.data);
//       } else if (type === "lawFirmClient") {
//         var data = response.data.data;
//         const clientdata =
//           data.length > 0 &&
//           data.map((h, id) => {
//             return { [h.id]: h.name };
//           });
//         setClientData(clientdata);
//       }
//     } catch (error) {
//       console.error("Error filtering data");
//     }
//   };

//   // const apiUrl = `${API_SINGLE_LOTS_CASE}${extractedValue}`;
//   const getTableRecords = async () => {
//     setLoading(true);
//     const hash = window.location.hash;
//     const extractedValue = hash.split('/').pop();
//     const apiUrl = `${API_SINGLE_LOTS_CASE}${extractedValue}?limit=${rowsPerPage}&page=${page + 1}`;
//     Axios.Get(apiUrl)
//       .then((response) => {
//         const resData = response.data;
//         if (response.status == 200) {
//           setList(resData.data);
//           setTotalCount(resData.total);
//           setLoading(false);
//         } else {
//           toast.error(resData.error);
//         }
//       })
//       .catch((err) => {
//         console.log(err, "wwwwwwwww");
//       });
//   };

//   const handleChangeSeat = (e) => {
//     const { value } = e.target;
//     setFormData((prevState) => ({
//       ...prevState,
//       seat: value,
//     }));
//   };

//   const refresh = () => {
//     setIsFiltered(false);
//     setFilteredPage(0);
//     setFilteredRowsPerPage(20);
//     setFormData({});
//     getTableRecords(page);
//   };

//   const redirectPage = () => {
//     props.props.history.goBack();
//   };

//   const allowCases = async () => {
//     Axios.Post(API_ALLOW_LOT_CASES + props.edit)
//       .then((res) => {
//         console.log(res, "reskjkj");
//         let response = res.data;
//         setLoading(false);

//         if (response.status === 200) {
//           toast.success(response.message);
//           setTimeout(() => {
//             redirectPage();
//           }, 1000);
//         } else {
//           toast.error(res.message);
//         }
//       })
//       .catch((error) => {
//         console.log(error, "error");
//         setLoading(false);
//       });
//   };

//   const disallowCases = async () => {
//     Axios.Post(API_DIS_ALLOW_LOT_CASES + props.edit)
//       .then((res) => {
//         console.log(res, "reskjkj");
//         let response = res.data;
//         setLoading(false);

//         if (response.status === 200) {
//           toast.success(response.message);
//           setTimeout(() => {
//             redirectPage();
//           }, 1000);
//         } else {
//           toast.error(res.message);
//         }
//       })
//       .catch((error) => {
//         console.log(error, "error");
//         setLoading(false);
//       });
//   };

//   const deleteAction = (id) => {
//     Axios.post(API_DELETE_CASES + id)
//       .then((res) => {
//         setOpen(false);
//         toast.success(res.data.message);
//       })
//       .catch((err) => {
//         setOpen(false);
//         toast.success("Cases does not deleted!");
//       });
//   };

//   const formatDate = (timestamp) => {
//     const date = new Date(timestamp);
//     const options = {
//       month: "long",
//       day: "numeric",
//       year: "numeric",
//     };
//     return date.toLocaleDateString("en-US", options);
//   };

//   const toggleRev1 = (index) => {
//     setVenue((prev) => (prev === index ? null : index));
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prevState) => ({
//       ...prevState,
//       [name]: value,
//     }));
//   };

//   const handleDateChange = (e) => {
//     const { name, value } = e.target;
//     const formattedDate = value
//       ? new Date(value).toISOString().split("T")[0]
//       : "";
//     setFormData({ ...formData, [name]: formattedDate });
//   };

//   const handleHearingDateChange = (e) => {
//     const { value } = e.target;
//     setFormData((prevState) => ({
//       ...prevState,
//       hearing_date: value,
//     }));
//   };

//   const handlenotassignChange = (e) => {
//     const { value } = e.target;
//     setFormData((prevState) => ({
//       ...prevState,
//       not_have_hearing_date: value,
//     }));
//   };

//   const handleChangeState = (e) => {
//     const { value } = e.target;
//     setFormData((prevState) => ({
//       ...prevState,
//       state: value,
//     }));
//   };

//   const handleChangeLot = (e) => {
//     const { value } = e.target;
//     setFormData((prevState) => ({
//       ...prevState,
//       lot: value,
//     }));
//   };

//   const handleChangeClient = (e) => {
//     const { value } = e.target;
//     setFormData((prevState) => ({
//       ...prevState,
//       client: value,
//     }));
//   };

//   const handleChangeDateRange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prevState) => ({
//       ...prevState,
//       [name]: value,
//     }));
//   };

//   const handleChangeHearingDateRange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prevState) => ({
//       ...prevState,
//       [name]: value,
//     }));
//   };

//   const handleConfirmSelection = () => {
//     setLoading(true);
//     const filteredFormData = Object.fromEntries(
//       Object.entries(formData).filter(([_, value]) => value !== "")
//     );

//     const payload = {
//       ...filteredFormData,
//       limit: filteredRowsPerPage,
//       page: filteredPage + 1,
//     };

//     Axios.post(API_FILTER_CASE, payload)
//       .then((response) => {
//         setList(response.data?.data);
//         setFilteredTotalCount(response.data?.total);
//         setShowModal(false);
//         setIsFiltered(true);
//         setLoading(false);
//       })
//       .catch((error) => {
//         console.error("Error occurred while fetching data:", error);
//         setLoading(false);
//       });
//   };

//   const handleOpenModal1 = () => {
//     setShowModal(true);
//   };

//   const handleCloseModal = () => setShowModal(false);

//   const cataloge =
//     list &&
//     list?.length > 0 &&
//     list?.map((item, index) => {
//       return (
//         <div className="single-revenue-conatiner" key={item.id}>
//           <div className="revenue-table-heading">
//             <p className="checkbox-revenue">
//               {" "}
//               {/* <span>
//                 <Checkbox
//                   key={item.id}
//                   type="checkbox"
//                   name={item.label}
//                   id={item.id}
//                   handleClick={(e) => handleClick(e, item.id)}
//                   isChecked={isCheck.includes(item.id)}
//                 />
//               </span> */}
//               <Link
//                 to={`/app/client/case-detail/${item.hash_id}`}
//                 data-toggle="tooltip"
//                 data-placement="top"
//                 title=""
//                 data-original-title="Case No."
//                 className="d-flex"
//               >
//                 {item.case_master_users.map((i) => {
//                   return (
//                     <div className="ml-2 text-capitalize">
//                       <span>
//                         {i.related_user_role == "Client" &&
//                           i.related_user_type == "claimant"
//                           ? `${i.related_user?.name}   vs`
//                           : ""}
//                       </span>

//                       <span>
//                         {i.related_user_role == "Party" &&
//                           i.related_user_type == "respondent"
//                           ? i.related_user?.name
//                           : ""}
//                       </span>
//                     </div>
//                   );
//                 })}
//               </Link>
//             </p>
//             <p className="checkbox-revenue-subtext">
//               <span> {item.date} </span>
//               <span className="revenue-status">{item.case_status}</span>
//             </p>
//           </div>
//           <Link to={`/app/client/case-detail/${item.hash_id}`}>
//             <div className="filesrevenue-conatiner">
//               <div className="filesrevenue-subconatiner">
//                 <div className="pov123 mt-3">
//                   <p>
//                     <span className="pov123Text">Case No.</span>
//                     {item.case_number}
//                   </p>
//                   <p>
//                     <span className="pov123Text">Filed On:</span>
//                     {moment(item.created_at).format("LLL")}
//                   </p>
//                 </div>
//               </div>

//               <div className="filesrevenue-subconatinerpov">
//                 {item.hearing &&
//                   item.hearing?.length > 0 &&
//                   item.hearing.map((hearing) => {
//                     const startDate = new Date(hearing?.hearing?.start_date);
//                     const currentDate = new Date();

//                     if (startDate >= currentDate) {
//                       return (
//                         <div
//                           className="filesrevenue-povBoxes"
//                           key={hearing.hearing_id}
//                         >
//                           <p>Next</p>
//                           <p>{formatDate(startDate)}</p>
//                         </div>
//                       );
//                     } else if (startDate < currentDate) {
//                       return (
//                         <div
//                           className="filesrevenue-povBoxes"
//                           key={hearing?.hearing_id}
//                         >
//                           <p>Previous</p>
//                           <p>{formatDate(startDate)}</p>
//                         </div>
//                       );
//                     }
//                   })}

//                 {!item.hearing ||
//                   (item?.hearing?.every(
//                     (hearing) =>
//                       new Date(hearing?.hearing?.start_date) >= new Date()
//                   ) && <></>)}
//               </div>
//             </div>
//           </Link>

//           {showVenue === index ? (
//             <div onClick={() => toggleRev1(index)}>
//               <h2 class="hr-lines">
//                 <span>
//                   <svg
//                     width="14"
//                     height="14"
//                     viewBox="0 0 14 14"
//                     fill="none"
//                     xmlns="http://www.w3.org/2000/svg"
//                   >
//                     <path
//                       d="M2 7.32349L7.32352 1.99996L12.6667 7.34311"
//                       stroke="#42526E"
//                       stroke-width="1.75"
//                       stroke-linecap="round"
//                       stroke-linejoin="round"
//                     />
//                   </svg>
//                 </span>
//               </h2>
//             </div>
//           ) : (
//             <div onClick={() => toggleRev1(index)} className="text-center">
//               <span className="arrow-conainer">
//                 <svg
//                   width="14"
//                   height="14"
//                   viewBox="0 0 14 14"
//                   fill="none"
//                   xmlns="http://www.w3.org/2000/svg"
//                 >
//                   <path
//                     d="M12.6667 7.34314L7.34317 12.6667L2.00002 7.32352"
//                     stroke="#42526E"
//                     stroke-width="1.75"
//                     stroke-linecap="round"
//                     stroke-linejoin="round"
//                   />
//                 </svg>
//               </span>
//             </div>
//           )}
//           {showVenue === index &&
//             item.metas.map((m) => {
//               return (
//                 <>
//                   <div className="revenue-state">
//                     <div className="revenue-state-box">
//                       <p className="text-court text-capitalize">
//                         {m.meta_key}:{" "}
//                       </p>
//                       <p className="text-state text-capitalize">
//                         {" "}
//                         {m.meta_value}{" "}
//                       </p>
//                     </div>
//                   </div>
//                 </>
//               );
//             })}
//         </div>
//       );
//     });

//   return (
//     <section className="Sales_analytics" style={{ paddingBottom: "42px" }}>
//       <DialogBox
//         title={"Cases"}
//         open={open}
//         onClose={handleClose}
//         deleteAction={deleteAction}
//       />
//       <div fluid>
//         <Row>
//           <Col md="8" xs="12" className="d-flex">
//             <Link
//               to="#"
//               onClick={handleGoBack}
//               style={{
//                 color: "grey",
//                 fontSize: "32px",
//               }}
//             >
//               <i
//                 class="zmdi zmdi-arrow-left"
//                 style={{
//                   fontSize: "22px",
//                   marginTop: "25px",
//                   marginLeft: "9px",
//                 }}
//               ></i>
//             </Link>
//             <div className="d-flex">
//               <p className="m-4">{localStorage.getItem("Pname")}</p>
//               <p className="m-4" style={{ whiteSpace: " pre-wrap" }}>
//                 {localStorage.getItem("description")}
//               </p>
//             </div>
//           </Col>

//           {/* <Col md="4" xs="12">
//             <Tooltip title="Need to select Template and checkboxe" arrow>
//               <button className=" mt-4 mr-5 allow-dis-btn" onClick={allowCases}>
//                 Approve
//               </button>
//             </Tooltip>

//             <Tooltip title="Need to select Template and checkboxe" arrow>
//               <button
//                 className=" mt-4 mr-5 dis-allow-btn"
//                 onClick={disallowCases}
//               >
//                 Dis Approve
//               </button>
//             </Tooltip>
//           </Col> */}

//         </Row>
//         <div className="revenueTable-conatiner">
//           <div className="revenueTable-pagination-box">
//             <div className="pgination-1st">
//               {" "}
//               {/* <span className="check-po-icon">
//                 <div class="form-check">
//                   <input
//                     class="form-check-input"
//                     type="checkbox"
//                     id="flexCheckDefault"
//                     onChange={handleSelectAll}
//                     isChecked={isCheckAll}
//                   />
//                 </div>
//               </span> */}
//               <span className="check-po-icon" onClick={refresh}>
//                 <i class="zmdi zmdi-refresh-alt"></i>
//               </span>
//               {/* <span className="check-po-icon" onClick={handleClickOpen}>
//                 <i class="zmdi zmdi-delete"></i>
//               </span> */}
//               <span className="check-po-icon" onClick={handleOpenModal1}>
//                 <span className="mr-2 mb-1">Filter</span>

//                 <img
//                   src={filter}
//                   alt=""
//                   style={{ width: " 20px", height: " 18px" }}
//                 />
//                 {/* <i class="zmdi zmdi-filter-list"></i> */}
//               </span>
//               <Modal isOpen={showModal} toggle={handleCloseModal}>
//                 <div className="modal-header">
//                   <button
//                     type="button"
//                     className="close"
//                     onClick={handleCloseModal}
//                   >
//                     <span>&times;</span>
//                   </button>
//                 </div>
//                 <ModalBody>
//                   <Row>
//                     <Col md="4" xs="12">
//                       <SELECT
//                         name="status"
//                         value={formData.status}
//                         onChange={handleChange}
//                         label="Status"
//                         data={[
//                           { pending: "Pending" },
//                           { disposed: "disposed" },
//                           { registered: "Registered" },
//                         ]}
//                       />
//                     </Col>
//                     <Col md="4" xs="12">
//                       <TEXTFIELD
//                         type="date"
//                         label="Created At"
//                         onChange={handleDateChange}
//                         value={formData.created_at}
//                         name="created_at"
//                       />
//                     </Col>

//                     <Col md="4">
//                       <SELECT
//                         onChange={handleChange}
//                         value={formData.arbitrator}
//                         name="arbitrator"
//                         label="Arbitrator"
//                         data={arbitratorData}
//                       />
//                     </Col>

//                     <Col md="4">
//                       <TEXTFIELD
//                         type="date"
//                         label="Hearing Date"
//                         onChange={handleHearingDateChange}
//                         value={formData.hearing_date}
//                         name="hearing_date"
//                       />
//                     </Col>
//                     <Col md="4">
//                       <SELECT
//                         onChange={handlenotassignChange}
//                         value={formData.not_have_hearing_date}
//                         name="not_have_hearing_date"
//                         label="Hearing not assigned"
//                         data={[{ yes: "Yes" }]}
//                       />
//                     </Col>
//                     <Col md="4">
//                       <SELECT
//                         onChange={handleChangeState}
//                         value={formData.state}
//                         name="state"
//                         label="State"
//                         data={stateData}
//                       />
//                     </Col>
//                     <Col md="4">
//                       <SELECT
//                         onChange={handleChangeSeat}
//                         value={formData.seat}
//                         name="seat"
//                         label="Seat"
//                         data={seatData}
//                       />
//                     </Col>
//                     <Col md="4">
//                       <SELECT
//                         onChange={handleChange}
//                         value={formData.venue}
//                         name="venue"
//                         id="variation-select-6"
//                         label="Venue"
//                         data={venueData}
//                       />
//                     </Col>

//                     <Col md="4">
//                       <SELECT
//                         name="lot"
//                         onChange={handleChangeLot}
//                         value={formData.client}
//                         id="variation-select-8"
//                         label="LOT"
//                         data={lotData}
//                       />
//                     </Col>
//                     <Col md="6" className="mt-4">
//                       <div>
//                         <label htmlFor="date_range" className="d-block">
//                           Created Date Range:
//                         </label>
//                         <div className="d-flex">
//                           <input
//                             type="date"
//                             id="date_range"
//                             name="created_at_from"
//                             value={formData.created_at_from}
//                             onChange={handleChangeDateRange}
//                             className="form-control mr-1"
//                           />
//                           <span className="align-self-center"> - </span>
//                           <input
//                             type="date"
//                             name="created_at_to"
//                             value={formData.created_at_to}
//                             onChange={handleChangeDateRange}
//                             className="form-control ml-1"
//                           />
//                         </div>
//                       </div>
//                     </Col>
//                     <Col md="6" className="mt-4">
//                       <div>
//                         <label htmlFor="date_range" className="d-block">
//                           Hearing Date Range:
//                         </label>
//                         <div className="d-flex">
//                           <input
//                             type="date"
//                             id="date_range"
//                             name="hearing_date_from"
//                             value={formData.hearing_date_from}
//                             onChange={handleChangeHearingDateRange}
//                             className="form-control mr-1"
//                           />
//                           <span className="align-self-center"> - </span>
//                           <input
//                             type="date"
//                             name="hearing_date_to"
//                             value={formData.hearing_date_to}
//                             onChange={handleChangeHearingDateRange}
//                             className="form-control ml-1"
//                           />
//                         </div>
//                       </div>
//                     </Col>
//                     <Col md="4" xs="12">
//                       <SELECT
//                         name="client"
//                         onChange={handleChangeClient}
//                         value={formData.client}
//                         id="variation-select-8"
//                         label="Client"
//                         data={clientData}
//                       />
//                     </Col>
//                   </Row>
//                   <Row>
//                     {" "}
//                     <Col md="4" xs="12">
//                       <Button
//                         color="primary"
//                         onClick={handleConfirmSelection}
//                         className="btn btn-warning add_claimant MuiButtonBase-root MuiButton-root jr-btn jr-btn-label left CBmargin CBmarginT M add-notes w-30"
//                       >
//                         Apply
//                       </Button>
//                     </Col>
//                   </Row>
//                 </ModalBody>
//               </Modal>
//             </div>
//             {/* <div className="pagination-conatinerw">
//               <div className="d-flex pagination-text justify-content-end">
//                 <span className="pto-5">Show</span>
//                 <select
//                   class="form-select page-select12"
//                   aria-label="Default select example"
//                   onChange={(event) => setLimit(event.target.value)}
//                 >
//                   {
//                     (list && list?.length > 10 && (
//                       <>
//                         <option selected>20</option>
//                         <option value="50">50</option>
//                         <option value="80">80</option>
//                         <option value="100">100</option>
//                       </>
//                     ))}
//                   <option value={list && list?.length}>
//                     {count == 0
//                       ? 0
//                       : filteredCatalogue && filteredCatalogue?.length > 0
//                         ? count
//                         : list && list?.length}{" "}
//                   </option>
//                 </select>
//                 <span className="pto-5">
//                   {" "}
//                   per page from{" "}
//                   {count == 0
//                     ? 0
//                     : filteredCatalogue && filteredCatalogue?.length > 0
//                       ? count
//                       : list && list?.length}{" "}
//                   results{" "}
//                 </span>
//               </div>
//               <nav>
//                 <ul className="pagination position-po pagination-text">
//                   <span className="pto-5">|</span>
//                   <li className="page-item pto-5">
//                     <span> Prev</span>
//                   </li>

//                   <li key="" className="">
//                     <a className="page-link" href="#">
//                       1
//                     </a>
//                   </li>

//                   <li className="page-item pto-5">
//                     <span>Next</span>
//                   </li>
//                 </ul>
//               </nav>
//             </div> */}
//           </div>

//           {loading === false && list && list?.length === 0 && (
//             <div className="n--data text-center m-5">No data Found!</div>
//           )}

//           {loading === true && (
//             <div className="n--data text-center m-5">
//               <Loading />
//             </div>
//           )}

//           <div className="revenue-scroll-container">{cataloge}</div>

//           <div>
//             {list && list.length > 0 && (
//               <div className="float-right">
//                 <DataTablePagination
//                   count={isFiltered ? filteredTotalCount : totalCount}
//                   rowsPerPage={isFiltered ? filteredRowsPerPage : rowsPerPage}
//                   page={isFiltered ? filteredPage : page}
//                   onChangePage={handleChangePage}
//                   onChangeRowsPerPage={handleChangeRowsPerPage}
//                   rowsPerPageOptions={[20, 50, 100, 200]}
//                 />
//               </div>
//             )}
//           </div>
//         </div>
//       </div>

//       <Modal isOpen={show} toggle={handleCancel}>
//         <p className="text-right m-0">
//           <span onClick={handleCancel} className="modal-cancel12">
//             <i class="zmdi zmdi-close"></i>
//           </span>
//         </p>
//         <ModalBody>
//           <p className="modal-case-12-heading">Case Limitation</p>
//           <form>
//             <Row>
//               <Col md="4" xs="12">
//                 <SELECT
//                   label="Chamber of arbitration"
//                   name={"role"}
//                   // value={role}
//                   // onChange={handleChange}
//                   data={[{ 1: "Active" }, { 0: "In Active" }]}
//                 />
//               </Col>
//               <Col md="4" xs="12">
//                 <SELECT
//                   label="Source Law Firm"
//                   name={"status"}
//                   // value={status}
//                   // onChange={handleChange}
//                   data={[{ 1: "Active" }, { 0: "In Active" }]}
//                 />
//               </Col>
//               <Col md="4" xs="12">
//                 <SELECT
//                   label="Arbitrator"
//                   name={"status"}
//                   // value={status}
//                   // onChange={handleChange}
//                   data={[{ 1: "Active" }, { 0: "In Active" }]}
//                 />
//               </Col>
//               <Col md="4" xs="12">
//                 <SELECT
//                   label="Arbitrator"
//                   name={"status"}
//                   // value={status}
//                   // onChange={handleChange}
//                   data={[{ 1: "Active" }, { 0: "In Active" }]}
//                 />
//               </Col>
//             </Row>
//           </form>
//         </ModalBody>
//       </Modal>
//     </section>
//   );
// };

// export default withRouter(Revenuetable);



// 2nd and latest this one 
// import React, { useState, useEffect } from "react";
// import { Button, Modal, ModalBody } from "reactstrap";
// import Tooltip from "@material-ui/core/Tooltip";
// import { withRouter } from 'react-router-dom';
// import Checkbox from "./checkbox";

// import {
//   Link,
//   ApiUrl,
//   Axios,
//   DialogBox,
//   Row,
//   Col,
//   SELECT,
//   toast,
//   Loading,
//   moment,
//   TEXTFIELD,
//   DataTablePagination,
// } from "../../../../../components";

// import filter from "../../../../../assets/images/icone-de-filtre-grise.png";

// const {
//   API_SINGLE_LOTS_CASE,
//   API_ALLOW_LOT_CASES,
//   API_DIS_ALLOW_LOT_CASES,
//   API_DELETE_CASES,
//   API_FILTER_CASE,
//   API_FILTER_SELECT_DATA,
//   DELETE_RESPONDENT_BY_ADMIN
// } = ApiUrl;

// const Revenuetable = (props) => {
//   const [show, setShow] = useState(false);
//   const [state, setState] = useState({
//     temp: "",
//     disabled: false,
//   });
//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(20);
//   const [totalCount, setTotalCount] = useState(0);
//   const [filteredPage, setFilteredPage] = useState(0);
//   const [filteredRowsPerPage, setFilteredRowsPerPage] = useState(20);
//   const [filteredTotalCount, setFilteredTotalCount] = useState(0);
//   const [isFiltered, setIsFiltered] = useState(false);
//   const [limit, setLimit] = useState(20);
//   const [showVenue, setVenue] = useState(false);
//   const [showModal, setShowModal] = useState(false);
//   const [isCheckAll, setIsCheckAll] = useState(false);
//   const [isCheck, setIsCheck] = useState([]);
//   const [confirmDelete, setConfirmDelete] = useState(false);
//   const [showConfirmModal, setShowConfirmModal] = useState(false);
//   const [list, setList] = useState([]);
//   const [temp, setTemp] = useState([]);
//   const [open, setOpen] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [responseData, setResponseData] = useState([]);
//   const [stateData, setStateData] = useState([]);
//   const [venueData, setVenueData] = useState([]);
//   const [arbitratorData, setArbitratorData] = useState([]);
//   const [seatData, setSeatData] = useState([]);
//   const [lotData, setLotData] = useState([]);
//   const [clientData, setClientData] = useState([]);
//   const [count, setCount] = useState();
//   const [formData, setFormData] = useState({
//     status: "",
//     created_at: "",
//     created_at_from: "",
//     created_at_to: "",
//     hearing_date_from: "",
//     arbitrator: "",
//     hearing_date: "",
//     not_have_hearing_date: "",
//     state: "",
//     seat: "",
//     venue: "",
//     client: "",
//     lot: "",
//   });
//   const [id, setId] = useState("");
//   const [detail, setDetail] = useState({
//     title: "",
//     des: "",
//   });

//   // useEffect(() => {
//   //   if (props.props.location.name) {
//   //     localStorage.setItem("Pname", props.props.location.name);
//   //   }
//   //   if (props.props.location.description) {
//   //     localStorage.setItem("description", props.props.location.description);
//   //   }
//   //   setDetail({
//   //     title: localStorage.getItem("Pname"),
//   //     des: localStorage.getItem("description"),
//   //   });
//   // }, [props.props.location.name, props.props.location.description]);

//   const handleGoBack = () => {
//     localStorage.removeItem("Pname");
//     localStorage.removeItem("description");
//     props.history.goBack();
//   }

//   const handleCancel = () => {
//     setShow(false);
//   };

//   const handlePreview = (id) => {
//     setShow(true);
//   };

//   useEffect(() => {
//     if (!isFiltered) {
//       getTableRecords();
//     }
//   }, [page, rowsPerPage, props.edit, isFiltered]);

//   useEffect(() => {
//     if (isFiltered) {
//       handleConfirmSelection();
//     }
//   }, [filteredPage, filteredRowsPerPage]);

//   useEffect(() => {
//     filterData("state");
//     filterData("venue");
//     filterData("stages");
//     filterData("arbitrator");
//     filterData("seat");
//     filterData("lot");
//     filterData("lawFirmClient");
//   }, []);

//   const handleChangePage = (event, newPage) => {
//     if (isFiltered) {
//       setFilteredPage(newPage);
//     } else {
//       setPage(newPage);
//     }
//   };

//   const handleChangeRowsPerPage = (event) => {
//     const newRowsPerPage = parseInt(event.target.value, 10);
//     if (isFiltered) {
//       const newTotalPages = Math.ceil(filteredTotalCount / newRowsPerPage) || 1;
//       setFilteredRowsPerPage(newRowsPerPage);
//       setFilteredPage(Math.min(filteredPage, Math.max(newTotalPages - 1, 0)));
//     } else {
//       const newTotalPages = Math.ceil(totalCount / newRowsPerPage) || 1;
//       setRowsPerPage(newRowsPerPage);
//       setPage(Math.min(page, Math.max(newTotalPages - 1, 0)));
//     }
//   };

//   const handleSelectAll = (e) => {
//     setIsCheckAll(!isCheckAll);
//     setIsCheck(list.map((li) => li.id));
//     if (isCheckAll) {
//       setIsCheck([]);
//     }
//   };

//   // const handleClickOpen = () => {
//   //   setOpen(true);
//   //   // setId(id)
//   // };

//   const handleClickOpen = () => {
//     if (isCheck.length === 0) {
//       toast.error("Please select at least one case to delete.");
//       return;
//     }
//     setShowConfirmModal(true);
//   };

//   const handleClose = () => {
//     setOpen(false);
//   };

//   const handleClick = (e, id) => {
//     const isChecked = isCheck.includes(id);
//     if (isChecked) {
//       setIsCheck(isCheck.filter((item) => item !== id));
//     } else {
//       setIsCheck([...isCheck, id]);
//     }
//   };

//   const filterData = async (type) => {
//     try {
//       const response = await Axios.get(API_FILTER_SELECT_DATA + `${type}`);
//       if (type === "state") {
//         var data = response.data.data;
//         const statedata =
//           data.length > 0 &&
//           data.map((h, id) => {
//             return { [h.state]: h.state };
//           });
//         setStateData(statedata);
//       } else if (type === "venue") {
//         var data = response.data.data;
//         const venuedata =
//           data.length > 0 &&
//           data.map((h) => {
//             return { [h.venue]: h.venue };
//           });
//         setVenueData(venuedata);
//       }
//       //  else if (type === "stages") {
//       //   setStagesData(response.data.data.map((item) => item.stage));
//       //   value;
//       // }
//       else if (type === "arbitrator") {
//         var data = response.data.data;
//         const arbitdata =
//           data.length > 0 &&
//           data.map((h, id) => {
//             return { [h.name]: h.name };
//           });
//         setArbitratorData(arbitdata);
//       } else if (type === "lot") {
//         var data = response.data.data;
//         const lotdata =
//           data.length > 0 &&
//           data.map((h) => {
//             return { [h.title]: h.title };
//           });
//         setLotData(lotdata);
//       } else if (type === "seat") {
//         var data = response.data.data;
//         const seatdata =
//           data.length > 0 &&
//           data.map((h) => {
//             return { [h.seat]: h.seat };
//           });
//         setSeatData(seatdata);
//       } else if (type === "stages") {
//         var data = response.data.data;

//         setStagingData(response.data.data);
//       } else if (type === "lawFirmClient") {
//         var data = response.data.data;
//         const clientdata =
//           data.length > 0 &&
//           data.map((h, id) => {
//             return { [h.id]: h.name };
//           });
//         setClientData(clientdata);
//       }
//     } catch (error) {
//       console.error("Error filtering data");
//     }
//   };

//   // const apiUrl = `${API_SINGLE_LOTS_CASE}${extractedValue}`;
//   const getTableRecords = async () => {
//     setLoading(true);
//     const hash = window.location.hash;
//     const extractedValue = hash.split('/').pop();
//     const apiUrl = `${API_SINGLE_LOTS_CASE}${extractedValue}?limit=${rowsPerPage}&page=${page + 1}`;
//     Axios.Get(apiUrl)
//       .then((response) => {
//         const resData = response.data;
//         if (response.status == 200) {
//           setList(resData.data);
//           setTotalCount(resData.total);
//           setLoading(false);
//         } else {
//           toast.error(resData.error);
//         }
//       })
//       .catch((err) => {
//         console.log(err, "wwwwwwwww");
//       });
//   };

//   const deletecases = () => {
//     if (confirmDelete) {
//       const payload = {
//         cases_id: isCheck,
//       };
//       try {
//         setState({ ...state, disabled: true });
//         setShowConfirmModal(false);
//         setLoading(true);
//         Axios.post(DELETE_RESPONDENT_BY_ADMIN, payload)
//           .then((response) => {
//             if (response.status === 200) {
//               toast.success("Case deleted successfully");
//               const updatedList = list.filter((item) => !isCheck.includes(item.id));
//               setList(updatedList);
//               getTableRecords();
//               setIsCheck([]);
//             } else {
//               toast.error("Error deleting case");
//             }
//           })
//           .catch((err) => {
//             const errorMessage = err.response?.data?.message || "Error deleting case";
//             toast.error(errorMessage);
//           })
//           .finally(() => {
//             setState({ ...state, disabled: false });
//             setLoading(false);
//             setShowConfirmModal(false);
//             setConfirmDelete(false);
//           });
//       } catch (err) {
//         toast.error("Unexpected error occurred while deleting case.");
//         setState({ ...state, disabled: false });
//         setLoading(false);
//         setShowConfirmModal(false);
//         setConfirmDelete(false);
//       }
//     }
//   };

//   useEffect(() => {
//     if (confirmDelete) {
//       deletecases();
//     }
//   }, [confirmDelete]);

//   const handleConfirmDelete = () => {
//     setConfirmDelete(true);
//   };

//   const handleCancelDelete = () => {
//     setShowConfirmModal(false);
//     setConfirmDelete(false);
//   };

//   const handleChangeSeat = (e) => {
//     const { value } = e.target;
//     setFormData((prevState) => ({
//       ...prevState,
//       seat: value,
//     }));
//   };

//   const refresh = () => {
//     setIsFiltered(false);
//     setFilteredPage(0);
//     setFilteredRowsPerPage(20);
//     setFormData({});
//     getTableRecords(page);
//   };

//   const redirectPage = () => {
//     props.props.history.goBack();
//   };

//   const allowCases = async () => {
//     Axios.Post(API_ALLOW_LOT_CASES + props.edit)
//       .then((res) => {
//         console.log(res, "reskjkj");
//         let response = res.data;
//         setLoading(false);

//         if (response.status === 200) {
//           toast.success(response.message);
//           setTimeout(() => {
//             redirectPage();
//           }, 1000);
//         } else {
//           toast.error(res.message);
//         }
//       })
//       .catch((error) => {
//         console.log(error, "error");
//         setLoading(false);
//       });
//   };

//   const disallowCases = async () => {
//     Axios.Post(API_DIS_ALLOW_LOT_CASES + props.edit)
//       .then((res) => {
//         console.log(res, "reskjkj");
//         let response = res.data;
//         setLoading(false);

//         if (response.status === 200) {
//           toast.success(response.message);
//           setTimeout(() => {
//             redirectPage();
//           }, 1000);
//         } else {
//           toast.error(res.message);
//         }
//       })
//       .catch((error) => {
//         console.log(error, "error");
//         setLoading(false);
//       });
//   };

//   const deleteAction = (id) => {
//     Axios.post(API_DELETE_CASES + id)
//       .then((res) => {
//         setOpen(false);
//         toast.success(res.data.message);
//       })
//       .catch((err) => {
//         setOpen(false);
//         toast.success("Cases does not deleted!");
//       });
//   };

//   const formatDate = (timestamp) => {
//     const date = new Date(timestamp);
//     const options = {
//       month: "long",
//       day: "numeric",
//       year: "numeric",
//     };
//     return date.toLocaleDateString("en-US", options);
//   };

//   const toggleRev1 = (index) => {
//     setVenue((prev) => (prev === index ? null : index));
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prevState) => ({
//       ...prevState,
//       [name]: value,
//     }));
//   };

//   const handleDateChange = (e) => {
//     const { name, value } = e.target;
//     const formattedDate = value
//       ? new Date(value).toISOString().split("T")[0]
//       : "";
//     setFormData({ ...formData, [name]: formattedDate });
//   };

//   const handleHearingDateChange = (e) => {
//     const { value } = e.target;
//     setFormData((prevState) => ({
//       ...prevState,
//       hearing_date: value,
//     }));
//   };

//   const handlenotassignChange = (e) => {
//     const { value } = e.target;
//     setFormData((prevState) => ({
//       ...prevState,
//       not_have_hearing_date: value,
//     }));
//   };

//   const handleChangeState = (e) => {
//     const { value } = e.target;
//     setFormData((prevState) => ({
//       ...prevState,
//       state: value,
//     }));
//   };

//   const handleChangeLot = (e) => {
//     const { value } = e.target;
//     setFormData((prevState) => ({
//       ...prevState,
//       lot: value,
//     }));
//   };

//   const handleChangeClient = (e) => {
//     const { value } = e.target;
//     setFormData((prevState) => ({
//       ...prevState,
//       client: value,
//     }));
//   };

//   const handleChangeDateRange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prevState) => ({
//       ...prevState,
//       [name]: value,
//     }));
//   };

//   const handleChangeHearingDateRange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prevState) => ({
//       ...prevState,
//       [name]: value,
//     }));
//   };

//   const handleConfirmSelection = () => {
//     setLoading(true);
//     const filteredFormData = Object.fromEntries(
//       Object.entries(formData).filter(([_, value]) => value !== "")
//     );

//     const payload = {
//       ...filteredFormData,
//       limit: filteredRowsPerPage,
//       page: filteredPage + 1,
//     };

//     Axios.post(API_FILTER_CASE, payload)
//       .then((response) => {
//         setList(response.data?.data);
//         setFilteredTotalCount(response.data?.total);
//         setShowModal(false);
//         setIsFiltered(true);
//         setLoading(false);
//       })
//       .catch((error) => {
//         console.error("Error occurred while fetching data:", error);
//         setLoading(false);
//       });
//   };

//   const handleOpenModal1 = () => {
//     setShowModal(true);
//   };

//   const handleCloseModal = () => setShowModal(false);

//   const cataloge =
//     list &&
//     list?.length > 0 &&
//     list?.map((item, index) => {
//       return (
//         <div className="single-revenue-conatiner" key={item.id}>
//           <div className="revenue-table-heading">
//             <p className="checkbox-revenue">
//               {" "}
//               <span style={{ marginLeft: '9px' }}>
//                 <Checkbox
//                   key={item.id}
//                   type="checkbox"
//                   name={item.label}
//                   id={item.id}
//                   handleClick={(e) => handleClick(e, item.id)}
//                   isChecked={isCheck.includes(item.id)}
//                 />
//               </span>
//               <Link
//                 to={`/app/client/case-detail/${item.hash_id}`}
//                 data-toggle="tooltip"
//                 data-placement="top"
//                 title=""
//                 data-original-title="Case No."
//                 className="d-flex"
//               >
//                 {item.case_master_users.map((i) => {
//                   return (
//                     <div className="ml-2 text-capitalize">
//                       <span>
//                         {i.related_user_role == "Client" &&
//                           i.related_user_type == "claimant"
//                           ? `${i.related_user?.name}   vs`
//                           : ""}
//                       </span>

//                       <span>
//                         {i.related_user_role == "Party" &&
//                           i.related_user_type == "respondent"
//                           ? i.related_user?.name
//                           : ""}
//                       </span>
//                     </div>
//                   );
//                 })}
//               </Link>
//             </p>
//             <p className="checkbox-revenue-subtext">
//               <span> {item.date} </span>
//               <span className="revenue-status">{item.case_status}</span>
//             </p>
//           </div>
//           <Link to={`/app/client/case-detail/${item.hash_id}`}>
//             <div className="filesrevenue-conatiner">
//               <div className="filesrevenue-subconatiner">
//                 <div className="pov123 mt-3">
//                   <p>
//                     <span className="pov123Text">Case No.</span>
//                     {item.case_number}
//                   </p>
//                   <p>
//                     <span className="pov123Text">Filed On:</span>
//                     {moment(item.created_at).format("LLL")}
//                   </p>
//                 </div>
//               </div>

//               <div className="filesrevenue-subconatinerpov">
//                 {item.hearing &&
//                   item.hearing?.length > 0 &&
//                   item.hearing.map((hearing) => {
//                     const startDate = new Date(hearing?.hearing?.start_date);
//                     const currentDate = new Date();

//                     if (startDate >= currentDate) {
//                       return (
//                         <div
//                           className="filesrevenue-povBoxes"
//                           key={hearing.hearing_id}
//                         >
//                           <p>Next</p>
//                           <p>{formatDate(startDate)}</p>
//                         </div>
//                       );
//                     } else if (startDate < currentDate) {
//                       return (
//                         <div
//                           className="filesrevenue-povBoxes"
//                           key={hearing?.hearing_id}
//                         >
//                           <p>Previous</p>
//                           <p>{formatDate(startDate)}</p>
//                         </div>
//                       );
//                     }
//                   })}

//                 {!item.hearing ||
//                   (item?.hearing?.every(
//                     (hearing) =>
//                       new Date(hearing?.hearing?.start_date) >= new Date()
//                   ) && <></>)}
//               </div>
//             </div>
//           </Link>

//           {showVenue === index ? (
//             <div onClick={() => toggleRev1(index)}>
//               <h2 class="hr-lines">
//                 <span>
//                   <svg
//                     width="14"
//                     height="14"
//                     viewBox="0 0 14 14"
//                     fill="none"
//                     xmlns="http://www.w3.org/2000/svg"
//                   >
//                     <path
//                       d="M2 7.32349L7.32352 1.99996L12.6667 7.34311"
//                       stroke="#42526E"
//                       stroke-width="1.75"
//                       stroke-linecap="round"
//                       stroke-linejoin="round"
//                     />
//                   </svg>
//                 </span>
//               </h2>
//             </div>
//           ) : (
//             <div onClick={() => toggleRev1(index)} className="text-center">
//               <span className="arrow-conainer">
//                 <svg
//                   width="14"
//                   height="14"
//                   viewBox="0 0 14 14"
//                   fill="none"
//                   xmlns="http://www.w3.org/2000/svg"
//                 >
//                   <path
//                     d="M12.6667 7.34314L7.34317 12.6667L2.00002 7.32352"
//                     stroke="#42526E"
//                     stroke-width="1.75"
//                     stroke-linecap="round"
//                     stroke-linejoin="round"
//                   />
//                 </svg>
//               </span>
//             </div>
//           )}
//           {showVenue === index &&
//             item.metas.map((m) => {
//               return (
//                 <>
//                   <div className="revenue-state">
//                     <div className="revenue-state-box">
//                       <p className="text-court text-capitalize">
//                         {m.meta_key}:{" "}
//                       </p>
//                       <p className="text-state text-capitalize">
//                         {" "}
//                         {m.meta_value}{" "}
//                       </p>
//                     </div>
//                   </div>
//                 </>
//               );
//             })}
//         </div>
//       );
//     });

//   return (
//     <section className="Sales_analytics" style={{ paddingBottom: "42px" }}>
//       <DialogBox
//         title={"Cases"}
//         open={open}
//         onClose={handleClose}
//         deleteAction={deleteAction}
//       />
//       <div fluid>
//         <Row>
//           <Col md="8" xs="12" className="d-flex">
//             <Link
//               to="#"
//               onClick={handleGoBack}
//               style={{
//                 color: "grey",
//                 fontSize: "32px",
//               }}
//             >
//               <i
//                 class="zmdi zmdi-arrow-left"
//                 style={{
//                   fontSize: "22px",
//                   marginTop: "25px",
//                   marginLeft: "9px",
//                 }}
//               ></i>
//             </Link>
//             <div className="d-flex">
//               <p className="m-4">{localStorage.getItem("Pname")}</p>
//               <p className="m-4" style={{ whiteSpace: " pre-wrap" }}>
//                 {localStorage.getItem("description")}
//               </p>
//             </div>
//           </Col>

//           {/* <Col md="4" xs="12">
//             <Tooltip title="Need to select Template and checkboxe" arrow>
//               <button className=" mt-4 mr-5 allow-dis-btn" onClick={allowCases}>
//                 Approve
//               </button>
//             </Tooltip>

//             <Tooltip title="Need to select Template and checkboxe" arrow>
//               <button
//                 className=" mt-4 mr-5 dis-allow-btn"
//                 onClick={disallowCases}
//               >
//                 Dis Approve
//               </button>
//             </Tooltip>
//           </Col> */}

//         </Row>
//         <div className="revenueTable-conatiner">
//           <div className="revenueTable-pagination-box">
//             <div className="pgination-1st">
//               {" "}
//               <span className="check-po-icon">
//                 <div class="form-check">
//                   <input
//                     class="form-check-input"
//                     type="checkbox"
//                     id="flexCheckDefault"
//                     onChange={handleSelectAll}
//                     isChecked={isCheckAll}
//                   />
//                 </div>
//               </span>
//               <span className="check-po-icon" onClick={refresh}>
//                 <i class="zmdi zmdi-refresh-alt"></i>
//               </span>
//               {/* <span className="check-po-icon" onClick={handleClickOpen}>
//                 <i class="zmdi zmdi-delete"></i>
//               </span> */}
//               <span className="check-po-icon" onClick={handleOpenModal1}>
//                 <span className="mr-2 mb-1">Filter</span>

//                 <img
//                   src={filter}
//                   alt=""
//                   style={{ width: " 20px", height: " 18px" }}
//                 />
//                 {/* <i class="zmdi zmdi-filter-list"></i> */}
//               </span>

//               <span className="check-po-icon" onClick={handleClickOpen}>
//                 <i className="zmdi zmdi-delete"></i>
//               </span>

//               <Modal isOpen={showModal} toggle={handleCloseModal}>
//                 <div className="modal-header">
//                   <button
//                     type="button"
//                     className="close"
//                     onClick={handleCloseModal}
//                   >
//                     <span>&times;</span>
//                   </button>
//                 </div>
//                 <ModalBody>
//                   <Row>
//                     <Col md="4" xs="12">
//                       <SELECT
//                         name="status"
//                         value={formData.status}
//                         onChange={handleChange}
//                         label="Status"
//                         data={[
//                           { pending: "Pending" },
//                           { disposed: "disposed" },
//                           { registered: "Registered" },
//                         ]}
//                       />
//                     </Col>
//                     <Col md="4" xs="12">
//                       <TEXTFIELD
//                         type="date"
//                         label="Created At"
//                         onChange={handleDateChange}
//                         value={formData.created_at}
//                         name="created_at"
//                       />
//                     </Col>

//                     <Col md="4">
//                       <SELECT
//                         onChange={handleChange}
//                         value={formData.arbitrator}
//                         name="arbitrator"
//                         label="Arbitrator"
//                         data={arbitratorData}
//                       />
//                     </Col>

//                     <Col md="4">
//                       <TEXTFIELD
//                         type="date"
//                         label="Hearing Date"
//                         onChange={handleHearingDateChange}
//                         value={formData.hearing_date}
//                         name="hearing_date"
//                       />
//                     </Col>
//                     <Col md="4">
//                       <SELECT
//                         onChange={handlenotassignChange}
//                         value={formData.not_have_hearing_date}
//                         name="not_have_hearing_date"
//                         label="Hearing not assigned"
//                         data={[{ yes: "Yes" }]}
//                       />
//                     </Col>
//                     <Col md="4">
//                       <SELECT
//                         onChange={handleChangeState}
//                         value={formData.state}
//                         name="state"
//                         label="State"
//                         data={stateData}
//                       />
//                     </Col>
//                     <Col md="4">
//                       <SELECT
//                         onChange={handleChangeSeat}
//                         value={formData.seat}
//                         name="seat"
//                         label="Seat"
//                         data={seatData}
//                       />
//                     </Col>
//                     <Col md="4">
//                       <SELECT
//                         onChange={handleChange}
//                         value={formData.venue}
//                         name="venue"
//                         id="variation-select-6"
//                         label="Venue"
//                         data={venueData}
//                       />
//                     </Col>

//                     <Col md="4">
//                       <SELECT
//                         name="lot"
//                         onChange={handleChangeLot}
//                         value={formData.client}
//                         id="variation-select-8"
//                         label="LOT"
//                         data={lotData}
//                       />
//                     </Col>
//                     <Col md="6" className="mt-4">
//                       <div>
//                         <label htmlFor="date_range" className="d-block">
//                           Created Date Range:
//                         </label>
//                         <div className="d-flex">
//                           <input
//                             type="date"
//                             id="date_range"
//                             name="created_at_from"
//                             value={formData.created_at_from}
//                             onChange={handleChangeDateRange}
//                             className="form-control mr-1"
//                           />
//                           <span className="align-self-center"> - </span>
//                           <input
//                             type="date"
//                             name="created_at_to"
//                             value={formData.created_at_to}
//                             onChange={handleChangeDateRange}
//                             className="form-control ml-1"
//                           />
//                         </div>
//                       </div>
//                     </Col>
//                     <Col md="6" className="mt-4">
//                       <div>
//                         <label htmlFor="date_range" className="d-block">
//                           Hearing Date Range:
//                         </label>
//                         <div className="d-flex">
//                           <input
//                             type="date"
//                             id="date_range"
//                             name="hearing_date_from"
//                             value={formData.hearing_date_from}
//                             onChange={handleChangeHearingDateRange}
//                             className="form-control mr-1"
//                           />
//                           <span className="align-self-center"> - </span>
//                           <input
//                             type="date"
//                             name="hearing_date_to"
//                             value={formData.hearing_date_to}
//                             onChange={handleChangeHearingDateRange}
//                             className="form-control ml-1"
//                           />
//                         </div>
//                       </div>
//                     </Col>
//                     <Col md="4" xs="12">
//                       <SELECT
//                         name="client"
//                         onChange={handleChangeClient}
//                         value={formData.client}
//                         id="variation-select-8"
//                         label="Client"
//                         data={clientData}
//                       />
//                     </Col>
//                   </Row>
//                   <Row>
//                     {" "}
//                     <Col md="4" xs="12">
//                       <Button
//                         color="primary"
//                         onClick={handleConfirmSelection}
//                         className="btn btn-warning add_claimant MuiButtonBase-root MuiButton-root jr-btn jr-btn-label left CBmargin CBmarginT M add-notes w-30"
//                       >
//                         Apply
//                       </Button>
//                     </Col>
//                   </Row>
//                 </ModalBody>
//               </Modal>
//             </div>
//             {/* <div className="pagination-conatinerw">
//               <div className="d-flex pagination-text justify-content-end">
//                 <span className="pto-5">Show</span>
//                 <select
//                   class="form-select page-select12"
//                   aria-label="Default select example"
//                   onChange={(event) => setLimit(event.target.value)}
//                 >
//                   {
//                     (list && list?.length > 10 && (
//                       <>
//                         <option selected>20</option>
//                         <option value="50">50</option>
//                         <option value="80">80</option>
//                         <option value="100">100</option>
//                       </>
//                     ))}
//                   <option value={list && list?.length}>
//                     {count == 0
//                       ? 0
//                       : filteredCatalogue && filteredCatalogue?.length > 0
//                         ? count
//                         : list && list?.length}{" "}
//                   </option>
//                 </select>
//                 <span className="pto-5">
//                   {" "}
//                   per page from{" "}
//                   {count == 0
//                     ? 0
//                     : filteredCatalogue && filteredCatalogue?.length > 0
//                       ? count
//                       : list && list?.length}{" "}
//                   results{" "}
//                 </span>
//               </div>
//               <nav>
//                 <ul className="pagination position-po pagination-text">
//                   <span className="pto-5">|</span>
//                   <li className="page-item pto-5">
//                     <span> Prev</span>
//                   </li>

//                   <li key="" className="">
//                     <a className="page-link" href="#">
//                       1
//                     </a>
//                   </li>

//                   <li className="page-item pto-5">
//                     <span>Next</span>
//                   </li>
//                 </ul>
//               </nav>
//             </div> */}
//           </div>

//           {loading === false && list && list?.length === 0 && (
//             <div className="n--data text-center m-5">No data Found!</div>
//           )}

//           {loading === true && (
//             <div className="n--data text-center m-5">
//               <Loading />
//             </div>
//           )}

//           <div className="revenue-scroll-container">{cataloge}</div>

//           <div>
//             {list && list.length > 0 && (
//               <div className="float-right">
//                 <DataTablePagination
//                   count={isFiltered ? filteredTotalCount : totalCount}
//                   rowsPerPage={isFiltered ? filteredRowsPerPage : rowsPerPage}
//                   page={isFiltered ? filteredPage : page}
//                   onChangePage={handleChangePage}
//                   onChangeRowsPerPage={handleChangeRowsPerPage}
//                   rowsPerPageOptions={[20, 50, 100, 200]}
//                 />
//               </div>
//             )}
//           </div>
//         </div>
//       </div>

//       <Modal isOpen={showConfirmModal} toggle={handleCancelDelete} className="full-screen-modal">
//         <div className=" modal-top d-flex justify-content-between py-1 pt-3 px-3">
//           <p className="fs-18 fw-bold">Delete Confirmation</p>
//           <p className="">
//             <span onClick={handleCancelDelete} className="modal-cancel12">
//               <i className="zmdi zmdi-close"></i>
//             </span>
//           </p>
//         </div>
//         <ModalBody className="pt-0">
//           <p>Are you sure you want to delete the selected cases?</p>
//           <Button
//             color="danger"
//             onClick={handleConfirmDelete}
//             disabled={state.disabled}
//           >
//             Confirm
//           </Button>
//           <Button
//             color="secondary"
//             onClick={handleCancelDelete}
//             className="ml-2"
//           >
//             Cancel
//           </Button>
//         </ModalBody>
//       </Modal>

//       <Modal isOpen={show} toggle={handleCancel}>
//         <p className="text-right m-0">
//           <span onClick={handleCancel} className="modal-cancel12">
//             <i class="zmdi zmdi-close"></i>
//           </span>
//         </p>
//         <ModalBody>
//           <p className="modal-case-12-heading">Case Limitation</p>
//           <form>
//             <Row>
//               <Col md="4" xs="12">
//                 <SELECT
//                   label="Chamber of arbitration"
//                   name={"role"}
//                   // value={role}
//                   // onChange={handleChange}
//                   data={[{ 1: "Active" }, { 0: "In Active" }]}
//                 />
//               </Col>
//               <Col md="4" xs="12">
//                 <SELECT
//                   label="Source Law Firm"
//                   name={"status"}
//                   // value={status}
//                   // onChange={handleChange}
//                   data={[{ 1: "Active" }, { 0: "In Active" }]}
//                 />
//               </Col>
//               <Col md="4" xs="12">
//                 <SELECT
//                   label="Arbitrator"
//                   name={"status"}
//                   // value={status}
//                   // onChange={handleChange}
//                   data={[{ 1: "Active" }, { 0: "In Active" }]}
//                 />
//               </Col>
//               <Col md="4" xs="12">
//                 <SELECT
//                   label="Arbitrator"
//                   name={"status"}
//                   // value={status}
//                   // onChange={handleChange}
//                   data={[{ 1: "Active" }, { 0: "In Active" }]}
//                 />
//               </Col>
//             </Row>
//           </form>
//         </ModalBody>
//       </Modal>
//     </section>
//   );
// };

// export default withRouter(Revenuetable);



import React, { useState, useEffect } from "react";
import { Button, Modal, ModalBody } from "reactstrap";
import Tooltip from "@material-ui/core/Tooltip";
import { withRouter } from 'react-router-dom';
import { FaEdit, FaMapMarkedAlt } from 'react-icons/fa';
import Checkbox from "./checkbox";

import {
  Link,
  ApiUrl,
  Axios,
  DialogBox,
  Row,
  Col,
  SELECT,
  toast,
  Loading,
  SUBMIT,
  moment,
  TEXTFIELD,
  DataTablePagination,
} from "../../../../../components";

import ArbitList from "../../../Lawfirm/clients/routes/Components/arbitlist";
import filter from "../../../../../assets/images/icone-de-filtre-grise.png";
import eventEmitter from "../../../../../util/emitter";
import SelectSearchadmin from "../../../Lawfirm/clients/routes/Components/files/selectSearchadmin";
import SelectSearchzoomdelete from "../../../Lawfirm/clients/routes/Components/files/selectSearchzoomdelete";

const {
  API_SINGLE_LOTS_CASE,
  API_ALLOW_LOT_CASES,
  API_DIS_ALLOW_LOT_CASES,
  API_DELETE_CASES,
  API_FILTER_CASE,
  API_FILTER_SELECT_DATA,
  DELETE_RESPONDENT_BY_ADMIN,
  GET_BULK_HEARINGS_RECORDINGS,
  DELETE_USER_BY_EXCEL
} = ApiUrl;

const Revenuetable = (props) => {
  const fromComponent1 = props.location.state?.fromComponent1 || false;
  const [show, setShow] = useState(false);
  const [state, setState] = useState({
    temp: "",
    disabled: false,
  });
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [totalCount, setTotalCount] = useState(0);
  const [filteredPage, setFilteredPage] = useState(0);
  const [filteredRowsPerPage, setFilteredRowsPerPage] = useState(20);
  const [filteredTotalCount, setFilteredTotalCount] = useState(0);
  const [isFiltered, setIsFiltered] = useState(false);
  const [limit, setLimit] = useState(20);
  const [dropdownState, setDropdownState] = useState(null);
  const [showVenue, setVenue] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [isCheckAll, setIsCheckAll] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [file, setFile] = useState("");
  const [respondentNames, setRespondentNames] = useState([]);
  const [showRespondentModal, setShowRespondentModal] = useState(false);
  const [fileName, setFileName] = useState("");
  const [isCheck, setIsCheck] = useState([]);
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [list, setList] = useState([]);
  const [temp, setTemp] = useState([]);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [responseData, setResponseData] = useState([]);
  const [stateData, setStateData] = useState([]);
  const [venueData, setVenueData] = useState([]);
  const [arbitratorData, setArbitratorData] = useState([]);
  const [selectedRespondent, setSelectedRespondent] = useState(null);
  const [showStatus, setShowStatus] = useState(false);
  const [seatData, setSeatData] = useState([]);
  const [lotData, setLotData] = useState([]);
  const [clientData, setClientData] = useState([]);
  const [count, setCount] = useState();
  const [showNoticeA, setShowNoticeA] = useState(false);
  const [showNoticeCerti, setShowNoticeCerti] = useState(false);
  const [isZoomDeleteModalOpen, setIsZoomDeleteModalOpen] = useState(false);
  const [formData, setFormData] = useState({
    status: "",
    created_at: "",
    created_at_from: "",
    created_at_to: "",
    hearing_date_from: "",
    arbitrator: "",
    hearing_date: "",
    not_have_hearing_date: "",
    state: "",
    seat: "",
    venue: "",
    client: "",
    lot: "",
  });
  const [id, setId] = useState("");
  const [detail, setDetail] = useState({
    title: "",
    des: "",
  });

  // useEffect(() => {
  //   if (props.props.location.name) {
  //     localStorage.setItem("Pname", props.props.location.name);
  //   }
  //   if (props.props.location.description) {
  //     localStorage.setItem("description", props.props.location.description);
  //   }
  //   setDetail({
  //     title: localStorage.getItem("Pname"),
  //     des: localStorage.getItem("description"),
  //   });
  // }, [props.props.location.name, props.props.location.description]);

  const handleGoBack = () => {
    localStorage.removeItem("Pname");
    localStorage.removeItem("description");
    props.history.goBack();
  }

  const handleRespondentSelect = (respondent) => {
    setSelectedRespondent(respondent);
    setShowRespondentModal(false);
  };

  const handleCancel = () => {
    setShow(false);
  };

  const handlePreviewCerti = () => {
    setShowNoticeCerti(true);
  };

  const handleCancelStatus = () => {
    setShowStatus(false);
  };

  const openZoomDeleteModal = () => {
    setIsZoomDeleteModalOpen(true);
  };

  const handlePreview = (id) => {
    setShow(true);
  };

  const handleCancelA = () => {
    setShowNoticeA(false);
  };

  const handleShowModal = () => {
    setShowConfirmModal(true);
  };

  const handleCancelCerti = () => {
    setShowNoticeCerti(false);
  };

  const closeZoomDeleteModal = () => {
    setIsZoomDeleteModalOpen(false);
  };

  useEffect(() => {
    if (!isFiltered) {
      getTableRecords();
    }
  }, [page, rowsPerPage, props.edit, isFiltered]);

  useEffect(() => {
    if (isFiltered) {
      handleConfirmSelection();
    }
  }, [filteredPage, filteredRowsPerPage]);

  useEffect(() => {
    const handleCloseModal = () => {
      setShowNoticeCerti(false);
    };
    eventEmitter.on("closeModal", handleCloseModal);
    return () => {
      eventEmitter.off("closeModal", handleCloseModal);
    };
  }, []);

  useEffect(() => {
    const closeZoomDeleteModal = () => {
      setIsZoomDeleteModalOpen(false);
    };
    eventEmitter.on("closeZoomModal", closeZoomDeleteModal);
    return () => {
      eventEmitter.off("closeZoomModal", closeZoomDeleteModal);
    };
  }, []);

  useEffect(() => {
    filterData("state");
    filterData("venue");
    filterData("stages");
    filterData("arbitrator");
    filterData("seat");
    filterData("lot");
    filterData("lawFirmClient");
  }, []);

  const handleChangePage = (event, newPage) => {
    if (isFiltered) {
      setFilteredPage(newPage);
    } else {
      setPage(newPage);
    }
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      const allowedTypes = [
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/vnd.ms-excel",
      ];
      if (!allowedTypes.includes(selectedFile.type)) {
        setHasError(true);
        toast.error("Please upload a valid Excel file.");
      } else {
        setHasError(false);
        setFile(selectedFile);
      }
    } else {
      setHasError(true);
    }
  };

  const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    if (isFiltered) {
      const newTotalPages = Math.ceil(filteredTotalCount / newRowsPerPage) || 1;
      setFilteredRowsPerPage(newRowsPerPage);
      setFilteredPage(Math.min(filteredPage, Math.max(newTotalPages - 1, 0)));
    } else {
      const newTotalPages = Math.ceil(totalCount / newRowsPerPage) || 1;
      setRowsPerPage(newRowsPerPage);
      setPage(Math.min(page, Math.max(newTotalPages - 1, 0)));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData();
    const file = document.getElementById('fileUpload').files[0];
    if (!file) {
      toast.error("Please select a file");
      return;
    }
    formData.append('case_file', file);
    Axios.post(DELETE_USER_BY_EXCEL, formData)
      .then((res) => {
        if (res.data.success) {
          toast.success("Case deleted successfully");
          getTableRecords();
          setShowStatus(false);
        } else if (res.status === 200) {
          toast.error("no data found.");
        } else {
          toast.error(res.data.error?.case_file?.[0] || "Error deleting case");
        }
      })
      .catch((error) => {
        console.error(error);
        toast.error("An error occurred while deleting the case");
      });
  };

  const hearingsdownload = async () => {
    eventEmitter.emit("SHOW_FULL_LOADER");
    const payload = {
      cases_id: isCheck,
    };
    Axios.post(GET_BULK_HEARINGS_RECORDINGS, payload)
      .then((response) => {
        const { filename, zip_content } = response.data;
        const byteCharacters = atob(zip_content);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: "application/zip" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch((error) => {
        console.error("Error occurred while fetching data:", error);
      })
      .finally(() => {
        eventEmitter.emit("HIDE_FULL_LOADER");
      });
  };

  const handleSelectAll = (e) => {
    setIsCheckAll(!isCheckAll);
    setIsCheck(list.map((li) => li.id));
    if (isCheckAll) {
      setIsCheck([]);
    }
  };

  const showErrorN = () => {
    toast.error("Please select checkbox first");
  };

  const handlePreviewStatus = () => {
    setShowStatus(true);
  };

  const handlePreviewA = () => {
    setShowNoticeA(true);
  };

  // const handleClickOpen = () => {
  //   setOpen(true);
  //   // setId(id)
  // };

  const handleClickOpen = () => {
    if (isCheck.length === 0) {
      toast.error("Please select at least one case to delete.");
      return;
    }
    setShowConfirmModal(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleClick = (e, id) => {
    const isChecked = isCheck.includes(id);
    if (isChecked) {
      setIsCheck(isCheck.filter((item) => item !== id));
    } else {
      setIsCheck([...isCheck, id]);
    }
  };

  const filterData = async (type) => {
    try {
      const response = await Axios.get(API_FILTER_SELECT_DATA + `${type}`);
      if (type === "state") {
        var data = response.data.data;
        const statedata =
          data.length > 0 &&
          data.map((h, id) => {
            return { [h.state]: h.state };
          });
        setStateData(statedata);
      } else if (type === "venue") {
        var data = response.data.data;
        const venuedata =
          data.length > 0 &&
          data.map((h) => {
            return { [h.venue]: h.venue };
          });
        setVenueData(venuedata);
      }
      //  else if (type === "stages") {
      //   setStagesData(response.data.data.map((item) => item.stage));
      //   value;
      // }
      else if (type === "arbitrator") {
        var data = response.data.data;
        const arbitdata =
          data.length > 0 &&
          data.map((h, id) => {
            return { [h.name]: h.name };
          });
        setArbitratorData(arbitdata);
      } else if (type === "lot") {
        var data = response.data.data;
        const lotdata =
          data.length > 0 &&
          data.map((h) => {
            return { [h.title]: h.title };
          });
        setLotData(lotdata);
      } else if (type === "seat") {
        var data = response.data.data;
        const seatdata =
          data.length > 0 &&
          data.map((h) => {
            return { [h.seat]: h.seat };
          });
        setSeatData(seatdata);
      } else if (type === "stages") {
        var data = response.data.data;

        setStagingData(response.data.data);
      } else if (type === "lawFirmClient") {
        var data = response.data.data;
        const clientdata =
          data.length > 0 &&
          data.map((h, id) => {
            return { [h.id]: h.name };
          });
        setClientData(clientdata);
      }
    } catch (error) {
      console.error("Error filtering data");
    }
  };

  // const apiUrl = `${API_SINGLE_LOTS_CASE}${extractedValue}`;
  const getTableRecords = async () => {
    setLoading(true);
    const hash = window.location.hash;
    const extractedValue = hash.split('/').pop();
    const apiUrl = `${API_SINGLE_LOTS_CASE}${extractedValue}?limit=${rowsPerPage}&page=${page + 1}`;
    Axios.Get(apiUrl)
      .then((response) => {
        const resData = response.data;
        if (response.status == 200) {
          setList(resData.data);
          setTotalCount(resData.total);
          setLoading(false);
        } else {
          toast.error(resData.error);
        }
      })
      .catch((err) => {
        console.log(err, "wwwwwwwww");
      });
  };

  const deletecases = () => {
    if (confirmDelete) {
      const payload = {
        cases_id: isCheck,
      };
      try {
        setState({ ...state, disabled: true });
        setShowConfirmModal(false);
        setLoading(true);
        Axios.post(DELETE_RESPONDENT_BY_ADMIN, payload)
          .then((response) => {
            if (response.status === 200) {
              toast.success("Case deleted successfully");
              const updatedList = list.filter((item) => !isCheck.includes(item.id));
              setList(updatedList);
              getTableRecords();
              setIsCheck([]);
            } else {
              toast.error("Error deleting case");
            }
          })
          .catch((err) => {
            const errorMessage = err.response?.data?.message || "Error deleting case";
            toast.error(errorMessage);
          })
          .finally(() => {
            setState({ ...state, disabled: false });
            setLoading(false);
            setShowConfirmModal(false);
            setConfirmDelete(false);
          });
      } catch (err) {
        toast.error("Unexpected error occurred while deleting case.");
        setState({ ...state, disabled: false });
        setLoading(false);
        setShowConfirmModal(false);
        setConfirmDelete(false);
      }
    }
  };

  useEffect(() => {
    if (confirmDelete) {
      deletecases();
    }
  }, [confirmDelete]);

  const handleConfirmDelete = () => {
    setConfirmDelete(true);
  };

  const handleCancelDelete = () => {
    setShowConfirmModal(false);
    setConfirmDelete(false);
  };

  const handleChangeSeat = (e) => {
    const { value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      seat: value,
    }));
  };

  const handleFile = (event) => {
    event.preventDefault();
    let selectedFile = event.target.files[0];
    let newErr = { file: "" };
    console.log(selectedFile, "filefile");
    setFile(selectedFile);
    setFileName(selectedFile.name);
  };

  const refresh = () => {
    setIsFiltered(false);
    setFilteredPage(0);
    setFilteredRowsPerPage(20);
    setFormData({});
    getTableRecords(page);
    setFile("");
    setFileName("");
  };

  const redirectPage = () => {
    props.props.history.goBack();
  };

  const allowCases = async () => {
    Axios.Post(API_ALLOW_LOT_CASES + props.edit)
      .then((res) => {
        console.log(res, "reskjkj");
        let response = res.data;
        setLoading(false);
        if (response.status === 200) {
          toast.success(response.message);
          setTimeout(() => {
            redirectPage();
          }, 1000);
        } else {
          toast.error(res.message);
        }
      })
      .catch((error) => {
        console.log(error, "error");
        setLoading(false);
      });
  };

  const disallowCases = async () => {
    Axios.Post(API_DIS_ALLOW_LOT_CASES + props.edit)
      .then((res) => {
        console.log(res, "reskjkj");
        let response = res.data;
        setLoading(false);
        if (response.status === 200) {
          toast.success(response.message);
          setTimeout(() => {
            redirectPage();
          }, 1000);
        } else {
          toast.error(res.message);
        }
      })
      .catch((error) => {
        console.log(error, "error");
        setLoading(false);
      });
  };

  const deleteAction = (id) => {
    Axios.post(API_DELETE_CASES + id)
      .then((res) => {
        setOpen(false);
        toast.success(res.data.message);
      })
      .catch((err) => {
        setOpen(false);
        toast.success("Cases does not deleted!");
      });
  };

  const formatDate = (timestamp) => {
    const date = new Date(timestamp);
    const options = {
      month: "long",
      day: "numeric",
      year: "numeric",
    };
    return date.toLocaleDateString("en-US", options);
  };

  const toggleRev1 = (index) => {
    setVenue((prev) => (prev === index ? null : index));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleDateChange = (e) => {
    const { name, value } = e.target;
    const formattedDate = value
      ? new Date(value).toISOString().split("T")[0]
      : "";
    setFormData({ ...formData, [name]: formattedDate });
  };

  const handleHearingDateChange = (e) => {
    const { value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      hearing_date: value,
    }));
  };

  const handlenotassignChange = (e) => {
    const { value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      not_have_hearing_date: value,
    }));
  };

  const handleChangeState = (e) => {
    const { value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      state: value,
    }));
  };

  const handleChangeLot = (e) => {
    const { value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      lot: value,
    }));
  };

  const handleChangeClient = (e) => {
    const { value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      client: value,
    }));
  };

  const handleChangeDateRange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleChangeHearingDateRange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleConfirmSelection = () => {
    setLoading(true);
    const filteredFormData = Object.fromEntries(
      Object.entries(formData).filter(([_, value]) => value !== "")
    );
    const payload = {
      ...filteredFormData,
      limit: filteredRowsPerPage,
      page: filteredPage + 1,
    };
    Axios.post(API_FILTER_CASE, payload)
      .then((response) => {
        setList(response.data?.data);
        setFilteredTotalCount(response.data?.total);
        setShowModal(false);
        setIsFiltered(true);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error occurred while fetching data:", error);
        setLoading(false);
      });
  };

  const handleOpenModal1 = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => setShowModal(false);

  const handleDropdownToggle = (index) => {
    setDropdownState(dropdownState === index ? null : index);
  };

  const cataloge =
    list &&
    list?.length > 0 &&
    list?.map((item, index) => {
      const respondents = item.case_master_users.reduce((acc, i) => {
        if (
          i.related_user_role === "Party" &&
          i.related_user_type === "respondent"
        ) {
          acc.push({ id: i.related_user_id, name: i.related_user.name });
        }
        return acc;
      }, []);

      return (
        <div className="single-revenue-conatiner" key={item.id}>
          <div className="revenue-table-heading">
            <p className="checkbox-revenue">
              {" "}
              <span style={{ marginLeft: '9px' }}>
                <Checkbox
                  key={item.id}
                  type="checkbox"
                  name={item.label}
                  id={item.id}
                  handleClick={(e) => handleClick(e, item.id)}
                  isChecked={isCheck.includes(item.id)}
                />
              </span>
              <Link
                to={`/app/client/admin/case-detail/${item.hash_id}`}
                // to="#"
                data-toggle="tooltip"
                data-placement="top"
                title=""
                data-original-title="Case No."
                className="d-flex"
              >
                {item.case_master_users.map((i) => {
                  return (
                    <div className="ml-2 text-capitalize">
                      <span>
                        {i.related_user_role == "Client" &&
                          i.related_user_type == "claimant"
                          ? `${i.related_user?.name}   vs`
                          : ""}
                      </span>

                      <span>
                        {i.related_user_role == "Party" &&
                          i.related_user_type == "respondent"
                          ? i.related_user?.name
                          : ""}
                      </span>
                    </div>
                  );
                })}
              </Link>
            </p>

            <Link to={`/app/client/admin/case-detail/${item.hash_id}`} className="text-decoration-none text-dark">
            <p className="checkbox-revenue-subtext">
              <span> {item.date} </span>
              <span className="revenue-status">{item.case_status}</span>
            </p>
            </Link>

            <div className="button-dropdown-content" key={item.id}>
              <div className="px-1 time-name d-flex justify-content-between">
                <div className="dropdown">
                  <Button
                    className="m-0 p-0 border-0 bg-transparent shadow-none"
                    style={{ minWidth: "auto", display: "flex", alignItems: "center" }}
                    onClick={() => handleDropdownToggle(index)}
                  >
                    <i className="zmdi zmdi-more-vert" style={{ fontSize: "18px", color: "grey" }}></i>
                  </Button>
                  {dropdownState === index && (
                    <div className="dropdown-menu show  dropdown-shw showwwwwwwwwwwww">
                      {respondents.length > 1 ? (
                        <button
                          className="dropdown-item"
                          onClick={() => {
                            setRespondentNames(respondents);
                            setShowRespondentModal(true);
                            setDropdownState(null);
                          }}
                        >
                          <FaEdit className="mr-2" />
                          Edit Respondent
                        </button>
                      ) : (
                        <Link
                          to={`/app/client/admin/edit-respondent/${respondents[0].id}`}
                          className="dropdown-item d-flex"
                          data-toggle="tooltip"
                          data-placement="top"
                          title=""
                          data-original-title="Edit Respondent"
                        >
                          <FaEdit className="mr-2" />
                          Edit Respondent
                        </Link>
                      )}

                      <Link
                        to={`/app/client/admin/edit-venue/${item.hash_id}`}
                        className="dropdown-item d-flex"
                        data-toggle="tooltip"
                        data-placement="top"
                        title=""
                        data-original-title="Edit Venue"
                      >
                        <FaMapMarkedAlt className="mr-2" />
                        Edit Venue
                      </Link>

                      {/* <button
                                      className="dropdown-item"
                                      onClick={() => handleDelete(item.id)}
                                      disabled={disabled}
                                    >
                                      <FaTrashAlt className="mr-2" />
                                      Delete
                                    </button> */}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          <Link to={`/app/client/admin/case-detail/${item?.hash_id}`}>
            <div className="filesrevenue-conatiner">
              <div className="filesrevenue-subconatiner">
                <div className="pov123 mt-3">
                  <p>
                    <span className="pov123Text">Case No.</span>
                    {item.case_number}
                  </p>
                  <p>
                    <span className="pov123Text">Filed On:</span>
                    {moment(item.created_at).format("LLL")}
                  </p>
                </div>
              </div>

              <div className="filesrevenue-subconatinerpov">
                {item.hearing &&
                  item.hearing?.length > 0 &&
                  item.hearing.map((hearing) => {
                    const startDate = new Date(hearing?.hearing?.start_date);
                    const currentDate = new Date();

                    if (startDate >= currentDate) {
                      return (
                        <div
                          className="filesrevenue-povBoxes"
                          key={hearing.hearing_id}
                        >
                          <p>Next</p>
                          <p>{formatDate(startDate)}</p>
                        </div>
                      );
                    } else if (startDate < currentDate) {
                      return (
                        <div
                          className="filesrevenue-povBoxes"
                          key={hearing?.hearing_id}
                        >
                          <p>Previous</p>
                          <p>{formatDate(startDate)}</p>
                        </div>
                      );
                    }
                  })}

                {!item.hearing ||
                  (item?.hearing?.every(
                    (hearing) =>
                      new Date(hearing?.hearing?.start_date) >= new Date()
                  ) && <></>)}
              </div>
            </div>
          </Link>

          {showVenue === index ? (
            <div onClick={() => toggleRev1(index)}>
              <h2 class="hr-lines">
                <span>
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M2 7.32349L7.32352 1.99996L12.6667 7.34311"
                      stroke="#42526E"
                      stroke-width="1.75"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </span>
              </h2>
            </div>
          ) : (
            <div onClick={() => toggleRev1(index)} className="text-center">
              <span className="arrow-conainer">
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12.6667 7.34314L7.34317 12.6667L2.00002 7.32352"
                    stroke="#42526E"
                    stroke-width="1.75"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </span>
            </div>
          )}
          {showVenue === index &&
            item.metas.map((m) => {
              return (
                <>
                  <div className="revenue-state">
                    <div className="revenue-state-box">
                      <p className="text-court text-capitalize">
                        {m.meta_key}:{" "}
                      </p>
                      <p className="text-state text-capitalize">
                        {" "}
                        {m.meta_value}{" "}
                      </p>
                    </div>
                  </div>
                </>
              );
            })}
        </div>
      );
    });

  return (
    <section className="Sales_analytics" style={{ paddingBottom: "42px" }}>
      <DialogBox
        title={"Cases"}
        open={open}
        onClose={handleClose}
        deleteAction={deleteAction}
      />
      <div fluid>
        <Row>
          <Col md="8" xs="12" className="d-flex">
            <Link
              to="#"
              onClick={handleGoBack}
              style={{
                color: "grey",
                fontSize: "32px",
              }}
            >
              <i
                class="zmdi zmdi-arrow-left"
                style={{
                  fontSize: "22px",
                  marginTop: "25px",
                  marginLeft: "9px",
                }}
              ></i>
            </Link>
            <div className="d-flex">
              <p className="m-4">{localStorage.getItem("Pname")}</p>
              <p className="m-4" style={{ whiteSpace: " pre-wrap" }}>
                {localStorage.getItem("description")}
              </p>
            </div>
          </Col>

          {!fromComponent1 && (
          <div className="buton-conatiner2431" style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
            <div className="box-rev-123 mt80 flex flex-nowrap mb-4" style={{ gap: 0 }}>
              <button
                className="gnrtarbit123 scrol-btn-genrte"
                onClick={isCheck == "" ? showErrorN : handlePreviewA}
              >
                Assign Arbitrator
              </button>
              <button
                className="gnrtaudit123 scrol-btn-genrte"
                onClick={isCheck == "" ? showErrorN : hearingsdownload}
              >
                Hearings Download
              </button>
              <button
                className="deletecases123 scrol-btn-genrte"
                onClick={isCheck == "" ? showErrorN : handleShowModal}
              >
                Delete Cases
              </button>
              <button
                className="gnrtaudit1234 scrol-btn-genrte"
                onClick={handlePreviewStatus}
              >
                Delete Cases by Excel
              </button>
              <button
                className="gnrtcertified123 scrol-btn-genrte"
                onClick={isCheck == "" ? showErrorN : handlePreviewCerti}
              >
                Delete Documents
              </button>
              <button
                className="zoomdelete123 scrol-btn-genrte"
                onClick={isCheck == "" ? showErrorN : openZoomDeleteModal}
              >
                Delete Hearings
              </button>
            </div>
          </div>
          )}

          {/* <Col md="4" xs="12">
            <Tooltip title="Need to select Template and checkboxe" arrow>
              <button className=" mt-4 mr-5 allow-dis-btn" onClick={allowCases}>
                Approve
              </button>
            </Tooltip>

            <Tooltip title="Need to select Template and checkboxe" arrow>
              <button
                className=" mt-4 mr-5 dis-allow-btn"
                onClick={disallowCases}
              >
                Dis Approve
              </button>
            </Tooltip>
          </Col> */}

        </Row>
        <div className="revenueTable-conatiner">
          <div className="revenueTable-pagination-box">
            <div className="pgination-1st">
              {" "}
              <span className="check-po-icon">
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    id="flexCheckDefault"
                    onChange={handleSelectAll}
                    isChecked={isCheckAll}
                  />
                </div>
              </span>
              <span className="check-po-icon" onClick={refresh}>
                <i class="zmdi zmdi-refresh-alt"></i>
              </span>
              {/* <span className="check-po-icon" onClick={handleClickOpen}>
                <i class="zmdi zmdi-delete"></i>
              </span> */}
              <span className="check-po-icon" onClick={handleOpenModal1}>
                <span className="mr-2 mb-1">Filter</span>

                <img
                  src={filter}
                  alt=""
                  style={{ width: " 20px", height: " 18px" }}
                />
                {/* <i class="zmdi zmdi-filter-list"></i> */}
              </span>

              {/* <span className="check-po-icon" onClick={handleClickOpen}>
                <i className="zmdi zmdi-delete"></i>
              </span> */}

              <Modal isOpen={showModal} toggle={handleCloseModal}>
                <div className="modal-header">
                  <button
                    type="button"
                    className="close"
                    onClick={handleCloseModal}
                  >
                    <span>&times;</span>
                  </button>
                </div>
                <ModalBody>
                  <Row>
                    <Col md="4" xs="12">
                      <SELECT
                        name="status"
                        value={formData.status}
                        onChange={handleChange}
                        label="Status"
                        data={[
                          { pending: "Pending" },
                          { disposed: "disposed" },
                          { registered: "Registered" },
                        ]}
                      />
                    </Col>
                    <Col md="4" xs="12">
                      <TEXTFIELD
                        type="date"
                        label="Created At"
                        onChange={handleDateChange}
                        value={formData.created_at}
                        name="created_at"
                      />
                    </Col>

                    <Col md="4">
                      <SELECT
                        onChange={handleChange}
                        value={formData.arbitrator}
                        name="arbitrator"
                        label="Arbitrator"
                        data={arbitratorData}
                      />
                    </Col>

                    <Col md="4">
                      <TEXTFIELD
                        type="date"
                        label="Hearing Date"
                        onChange={handleHearingDateChange}
                        value={formData.hearing_date}
                        name="hearing_date"
                      />
                    </Col>
                    <Col md="4">
                      <SELECT
                        onChange={handlenotassignChange}
                        value={formData.not_have_hearing_date}
                        name="not_have_hearing_date"
                        label="Hearing not assigned"
                        data={[{ yes: "Yes" }]}
                      />
                    </Col>
                    <Col md="4">
                      <SELECT
                        onChange={handleChangeState}
                        value={formData.state}
                        name="state"
                        label="State"
                        data={stateData}
                      />
                    </Col>
                    <Col md="4">
                      <SELECT
                        onChange={handleChangeSeat}
                        value={formData.seat}
                        name="seat"
                        label="Seat"
                        data={seatData}
                      />
                    </Col>
                    <Col md="4">
                      <SELECT
                        onChange={handleChange}
                        value={formData.venue}
                        name="venue"
                        id="variation-select-6"
                        label="Venue"
                        data={venueData}
                      />
                    </Col>

                    <Col md="4">
                      <SELECT
                        name="lot"
                        onChange={handleChangeLot}
                        value={formData.client}
                        id="variation-select-8"
                        label="LOT"
                        data={lotData}
                      />
                    </Col>
                    <Col md="6" className="mt-4">
                      <div>
                        <label htmlFor="date_range" className="d-block">
                          Created Date Range:
                        </label>
                        <div className="d-flex">
                          <input
                            type="date"
                            id="date_range"
                            name="created_at_from"
                            value={formData.created_at_from}
                            onChange={handleChangeDateRange}
                            className="form-control mr-1"
                          />
                          <span className="align-self-center"> - </span>
                          <input
                            type="date"
                            name="created_at_to"
                            value={formData.created_at_to}
                            onChange={handleChangeDateRange}
                            className="form-control ml-1"
                          />
                        </div>
                      </div>
                    </Col>
                    <Col md="6" className="mt-4">
                      <div>
                        <label htmlFor="date_range" className="d-block">
                          Hearing Date Range:
                        </label>
                        <div className="d-flex">
                          <input
                            type="date"
                            id="date_range"
                            name="hearing_date_from"
                            value={formData.hearing_date_from}
                            onChange={handleChangeHearingDateRange}
                            className="form-control mr-1"
                          />
                          <span className="align-self-center"> - </span>
                          <input
                            type="date"
                            name="hearing_date_to"
                            value={formData.hearing_date_to}
                            onChange={handleChangeHearingDateRange}
                            className="form-control ml-1"
                          />
                        </div>
                      </div>
                    </Col>
                    <Col md="4" xs="12">
                      <SELECT
                        name="client"
                        onChange={handleChangeClient}
                        value={formData.client}
                        id="variation-select-8"
                        label="Client"
                        data={clientData}
                      />
                    </Col>
                  </Row>
                  <Row>
                    {" "}
                    <Col md="4" xs="12">
                      <Button
                        color="primary"
                        onClick={handleConfirmSelection}
                        className="btn btn-warning add_claimant MuiButtonBase-root MuiButton-root jr-btn jr-btn-label left CBmargin CBmarginT M add-notes w-30"
                      >
                        Apply
                      </Button>
                    </Col>
                  </Row>
                </ModalBody>
              </Modal>
            </div>
            {/* <div className="pagination-conatinerw">
              <div className="d-flex pagination-text justify-content-end">
                <span className="pto-5">Show</span>
                <select
                  class="form-select page-select12"
                  aria-label="Default select example"
                  onChange={(event) => setLimit(event.target.value)}
                >
                  {
                    (list && list?.length > 10 && (
                      <>
                        <option selected>20</option>
                        <option value="50">50</option>
                        <option value="80">80</option>
                        <option value="100">100</option>
                      </>
                    ))}
                  <option value={list && list?.length}>
                    {count == 0
                      ? 0
                      : filteredCatalogue && filteredCatalogue?.length > 0
                        ? count
                        : list && list?.length}{" "}
                  </option>
                </select>
                <span className="pto-5">
                  {" "}
                  per page from{" "}
                  {count == 0
                    ? 0
                    : filteredCatalogue && filteredCatalogue?.length > 0
                      ? count
                      : list && list?.length}{" "}
                  results{" "}
                </span>
              </div>
              <nav>
                <ul className="pagination position-po pagination-text">
                  <span className="pto-5">|</span>
                  <li className="page-item pto-5">
                    <span> Prev</span>
                  </li>

                  <li key="" className="">
                    <a className="page-link" href="#">
                      1
                    </a>
                  </li>

                  <li className="page-item pto-5">
                    <span>Next</span>
                  </li>
                </ul>
              </nav>
            </div> */}
          </div>

          {loading === false && list && list?.length === 0 && (
            <div className="n--data text-center m-5">No data Found!</div>
          )}

          {loading === true && (
            <div className="n--data text-center m-5">
              <Loading />
            </div>
          )}

          <div className="revenue-scroll-container">{cataloge}</div>

          <div>
            {list && list.length > 0 && (
              <div className="float-right">
                <DataTablePagination
                  count={isFiltered ? filteredTotalCount : totalCount}
                  rowsPerPage={isFiltered ? filteredRowsPerPage : rowsPerPage}
                  page={isFiltered ? filteredPage : page}
                  onChangePage={handleChangePage}
                  onChangeRowsPerPage={handleChangeRowsPerPage}
                  rowsPerPageOptions={[20, 50, 100, 200]}
                />
              </div>
            )}
          </div>
        </div>
      </div>

      <Modal isOpen={showConfirmModal} toggle={handleCancelDelete} className="full-screen-modal">
        <div className=" modal-top d-flex justify-content-between py-1 pt-3 px-3">
          <p className="fs-18 fw-bold">Delete Confirmation</p>
          <p className="">
            <span onClick={handleCancelDelete} className="modal-cancel12">
              <i className="zmdi zmdi-close"></i>
            </span>
          </p>
        </div>
        <ModalBody className="pt-0">
          <p>Are you sure you want to delete the selected cases?</p>
          <Button
            color="danger"
            onClick={handleConfirmDelete}
            disabled={state.disabled}
          >
            Confirm
          </Button>
          <Button
            color="secondary"
            onClick={handleCancelDelete}
            className="ml-2"
          >
            Cancel
          </Button>
        </ModalBody>
      </Modal>

      <Modal
        isOpen={showRespondentModal}
        toggle={() => setShowRespondentModal(!showRespondentModal)}
      >
        <ModalBody>
          <h5>Select a Respondent You Want to Edit</h5>
          <ul>
            {respondentNames.map((respondent) => (
              <li key={respondent.id}>
                <Link
                  to={`/app/client/admin/edit-respondent/${respondent.id}`}
                  className="btn btn-link"
                  onClick={() => handleRespondentSelect(respondent)}
                >
                  {respondent.name}
                </Link>
              </li>
            ))}
          </ul>
        </ModalBody>
      </Modal>

      <Modal
        isOpen={isZoomDeleteModalOpen}
        toggle={closeZoomDeleteModal}
        className="generateCerti"
      >
        <p className="text-right m-0">
          <span onClick={closeZoomDeleteModal} className="modal-cancel12">
            <i class="zmdi zmdi-close"></i>
          </span>
        </p>
        <ModalBody>
          <p className="modal-case-12-heading text-center m-0">
            Please Search Zoom meeting topic for delete
          </p>
          <SelectSearchzoomdelete isCheck={isCheck} />
        </ModalBody>
      </Modal>

      <Modal isOpen={showStatus} toggle={handleCancelStatus} className="generateCerti">
        <p className="m10">
          <span className="filter-text ml-2">Delete Cases By Excel</span>
          <span onClick={handleCancelStatus} className="modal-cancel12 float-right">
            <i className="zmdi zmdi-close"></i>
          </span>
        </p>
        <ModalBody className="py-0 mt-2">
          <div>
            <form onSubmit={handleSubmit} noValidate>
              <Row>
                <Col md="12" xs="12">
                  <input
                    type="file"
                    id="fileUpload"
                    name="file"
                    className="form-control"
                    accept=".xls, .xlsx"
                    onChange={handleFileChange}
                  />
                </Col>
                <a
                  href="https://justsettle.in/backend/storage/templates/Delete-case.xlsx"
                  className="ml-3 download-templbrtn"
                >
                  Download Template For Reference
                </a>
                <Col md="12" xs="12">
                  <SUBMIT title="Submit" disabled={hasError || !file} />
                </Col>
              </Row>
            </form>
          </div>
        </ModalBody>
      </Modal>

      <Modal isOpen={show} toggle={handleCancel}>
        <p className="text-right m-0">
          <span onClick={handleCancel} className="modal-cancel12">
            <i class="zmdi zmdi-close"></i>
          </span>
        </p>
        <ModalBody>
          <p className="modal-case-12-heading">Case Limitation</p>
          <form>
            <Row>
              <Col md="4" xs="12">
                <SELECT
                  label="Chamber of arbitration"
                  name={"role"}
                  // value={role}
                  // onChange={handleChange}
                  data={[{ 1: "Active" }, { 0: "In Active" }]}
                />
              </Col>
              <Col md="4" xs="12">
                <SELECT
                  label="Source Law Firm"
                  name={"status"}
                  // value={status}
                  // onChange={handleChange}
                  data={[{ 1: "Active" }, { 0: "In Active" }]}
                />
              </Col>
              <Col md="4" xs="12">
                <SELECT
                  label="Arbitrator"
                  name={"status"}
                  // value={status}
                  // onChange={handleChange}
                  data={[{ 1: "Active" }, { 0: "In Active" }]}
                />
              </Col>
              <Col md="4" xs="12">
                <SELECT
                  label="Arbitrator"
                  name={"status"}
                  // value={status}
                  // onChange={handleChange}
                  data={[{ 1: "Active" }, { 0: "In Active" }]}
                />
              </Col>
            </Row>
          </form>
        </ModalBody>
      </Modal>

      <Modal
        isOpen={showNoticeCerti}
        toggle={handleCancelCerti}
        className="generateCerti"
      >
        <p className="text-right m-0">
          <span onClick={handleCancelCerti} className="modal-cancel12">
            <i class="zmdi zmdi-close"></i>
          </span>
        </p>
        <ModalBody>
          <p className="modal-case-12-heading text-center m-0">
            Please search document for delete
          </p>
          <SelectSearchadmin isCheck={isCheck} />
        </ModalBody>
      </Modal>

      <Modal isOpen={showNoticeA} toggle={handleCancelA}>
        <p className="text-right m-0">
          <span onClick={handleCancelA} className="modal-cancel12">
            <i class="zmdi zmdi-close"></i>
          </span>
        </p>
        <ModalBody>
          <>
            <div className="w-100">
              <ArbitList
                id={props.editId}
                casids={isCheck}
                detail={detail}
                handleCancelA={handleCancelA}
              />
            </div>
          </>
        </ModalBody>
      </Modal>
    </section>
  );
};

export default withRouter(Revenuetable);